import _Object$assign from '@babel/runtime-corejs3/core-js-stable/object/assign';
import _slicedToArray from '@babel/runtime-corejs3/helpers/esm/slicedToArray';
import _classCallCheck from '@babel/runtime-corejs3/helpers/esm/classCallCheck';
import _createClass from '@babel/runtime-corejs3/helpers/esm/createClass';
import _regeneratorRuntime from '@babel/runtime-corejs3/regenerator';
import _Promise from '@babel/runtime-corejs3/core-js-stable/promise';
import _JSON$stringify from '@babel/runtime-corejs3/core-js-stable/json/stringify';
import _reduceInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/reduce';
import _Object$entries from '@babel/runtime-corejs3/core-js-stable/object/entries';
import '@babel/runtime-corejs3/helpers/esm/typeof';
import '@babel/runtime-corejs3/core-js-stable/object/set-prototype-of';
import '@babel/runtime-corejs3/core-js-stable/object/create';
import _indexOfInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/index-of';
import _Object$getOwnPropertySymbols from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols';
import '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor';
import '@babel/runtime-corejs3/core-js-stable/object/define-property';
import '@babel/runtime-corejs3/core-js-stable/symbol';
import '@babel/runtime-corejs3/core-js-stable/symbol/iterator';
import '@babel/runtime-corejs3/core-js/get-iterator-method';
import _concatInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/concat';
import '@babel/runtime-corejs3/core-js-stable/instance/slice';
import '@babel/runtime-corejs3/core-js-stable/symbol/async-iterator';
import '@babel/runtime-corejs3/core-js/get-iterator';
import _filterInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/filter';
import _forEachInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/for-each';
import _setTimeout from '@babel/runtime-corejs3/core-js-stable/set-timeout';
import _Reflect$construct from '@babel/runtime-corejs3/core-js-stable/reflect/construct';
import _inherits from '@babel/runtime-corejs3/helpers/esm/inherits';
import _possibleConstructorReturn from '@babel/runtime-corejs3/helpers/esm/possibleConstructorReturn';
import _getPrototypeOf from '@babel/runtime-corejs3/helpers/esm/getPrototypeOf';
import _wrapNativeSuper from '@babel/runtime-corejs3/helpers/esm/wrapNativeSuper';
import _includesInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/includes';
import _URLSearchParams from '@babel/runtime-corejs3/core-js-stable/url-search-params';
import _URL from '@babel/runtime-corejs3/core-js-stable/url';
import _Date$now from '@babel/runtime-corejs3/core-js-stable/date/now';

function __rest(s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && _indexOfInstanceProperty(e).call(e, p) < 0) t[p] = s[p];
  if (s != null && typeof _Object$getOwnPropertySymbols === "function") for (var i = 0, p = _Object$getOwnPropertySymbols(s); i < p.length; i++) {
    if (_indexOfInstanceProperty(e).call(e, p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}
function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = _Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}

var EventBus = /*#__PURE__*/function () {
  function EventBus() {
    _classCallCheck(this, EventBus);
    this.listenerMap = {};
  }
  _createClass(EventBus, [{
    key: "on",
    value: function on(event, listener) {
      var _a;
      if (!this.listenerMap[event]) {
        this.listenerMap[event] = [];
      }
      (_a = this.listenerMap[event]) === null || _a === void 0 ? void 0 : _a.push(listener);
    }
  }, {
    key: "off",
    value: function off(event, listener) {
      var registeredListeners = this.listenerMap[event];
      if (registeredListeners) {
        this.listenerMap[event] = _filterInstanceProperty(registeredListeners).call(registeredListeners, function (registeredListener) {
          return registeredListener !== listener;
        });
      }
    }
  }, {
    key: "offAll",
    value: function offAll(event) {
      delete this.listenerMap[event];
    }
  }, {
    key: "dispatch",
    value: function dispatch(event) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }
      var _a;
      if (!this.listenerMap[event]) {
        return;
      }
      (_a = this.listenerMap[event]) === null || _a === void 0 ? void 0 : _forEachInstanceProperty(_a).call(_a, function (listener) {
        return listener.apply(void 0, args);
      });
    }
  }, {
    key: "once",
    value: function once(event, listener) {
      var _this = this;
      var onceListener = function onceListener() {
        listener.apply(void 0, arguments);
        _this.off(event, onceListener);
      };
      this.on(event, onceListener);
      return function () {
        return _this.off(event, onceListener);
      };
    }
  }, {
    key: "clear",
    value: function clear() {
      this.listenerMap = {};
    }
  }]);
  return EventBus;
}();

var EventDistributor = /*#__PURE__*/_createClass(function EventDistributor() {
  var _this = this;
  _classCallCheck(this, EventDistributor);
  this._eventBus = new EventBus();
  this.once = function (key, listener) {
    return _this._eventBus.once(key, listener);
  };
  this.dispatch = function (key) {
    var _this$_eventBus, _context;
    for (var _len = arguments.length, value = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      value[_key - 1] = arguments[_key];
    }
    (_this$_eventBus = _this._eventBus).dispatch.apply(_this$_eventBus, _concatInstanceProperty(_context = [key]).call(_context, value));
    _this._eventBus.offAll(key);
  };
});

var APP_TO_WEB_EVENT = {
  SET_TOKEN: 'setToken',
  SET_QUOTATION_TOKEN: 'setQuotationToken',
  SEND_GROUP_INFOS: 'sendGroupInfos',
  SEND_BACK_KEY: 'sendBackKey',
  SEND_USER_INFO: 'sendUserInfo',
  SEND_APP_INFO: 'sendAppInfo',
  SET_ALARM_STATE: 'setAlarmState',
  SET_FONT_SIZE_LEVEL: 'setFontSizeLevel',
  SET_EMERGENCY_SKIP: 'setEmergencySkip',
  SEND_CLICK_SHARED: 'sendClickShared',
  SET_ASSET_CHART_IMAGE: 'setAssetChartImage',
  SEND_APP_STORAGE_DATA: 'sendAppStorageData',
  SEND_WEB_VISIBLE: 'sendWebVisible',
  SEND_PULL_TO_REFRESH: 'sendPullToRefresh',
  SEND_EXPANDING_PROGRESS: 'sendExpandingProgress',
  SET_POST_TAG_FILTER: 'setPostTagFilter',
  SET_IS_AVAILABLE_FUNCTION: 'setIsAvailableFunction',
  SEND_SCROLL_TOP: 'sendScrollTop',
  SET_INVESTMENT_LEVEL_IMAGE: 'setInvestmentLevelImage',
  SEND_CLICK_POST_WRITE: 'sendClickPostWrite',
  SET_ATTACHMENT_ITEMS: 'setAttachmentItems',
  SEND_ENTER_COMMUNITY: 'sendEnterCommunity'
};

var BRIDGE_INTERFACE = {
  GET_TOKEN: 'getToken',
  GET_QUOTATION_TOKEN: 'getQuotationToken',
  CLOSE: 'close',
  SHOW_TOAST: 'showToast',
  SYNC_ACCOUNT: 'syncAccount',
  ON_UPDATE_STATE: 'onUpdateState',
  TRACK_EVENT: 'trackEvent',
  POST_AMPLITUDE_EVENT: 'postAmplitudeEvent',
  SECURITY_ACCOUNT_SYNC: 'securityAccountSync',
  CHANGE_TITLE: 'changeTitle',
  PAGE_PUSH: 'pagePush',
  SELECTED_GROUP: 'selectedGroup',
  SHOW_GROUP_STOCK_LISTS: 'showGroupStockLists',
  SHOW_EMPTY_STOCK_ANALYZE_REPORT: 'showEmptyStockAnalyzeReport',
  STOCK_ANALYZE_REGIST_STOCK: 'stockAnalyzeRegistStock',
  TOP_MENU_VISIBLE: 'topMenuVisible',
  GET_FAVORITE_GROUP_INFOS: 'getFavoriteGroupInfos',
  SHARE: 'share',
  GET_USER_INFO: 'getUserInfo',
  GET_APP_INFO: 'getAppInfo',
  PAGE_LOAD_CLEAR_HISTORY: 'pageLoadClearHistory',
  UPBIT_LINK: 'upbitLink',
  GET_ALARM_STATE: 'getAlarmState',
  LANDING_SETTING: 'landingSetting',
  POST_APPSFLYER_EVENT: 'postAppsflyerEvent',
  SET_WEB_CONTENT_HEIGHT: 'setWebContentHeight',
  GET_FONT_SIZE_LEVEL: 'getFontSizeLevel',
  GET_EMERGENCY_SKIP: 'getEmergencySkip',
  CALENDAR_ADD_GROUP: 'calendarAddGroup',
  COMPLETE_VERIFICATION: 'completeVerification',
  MOVE_TO_MAIN: 'moveToMain',
  ENABLE_RESIZE_BY_KEYBOARD: 'enableResizeByKeyboard',
  SHOW_POST_WRITE_BUTTON: 'showPostWriteButton',
  GET_ASSET_CHART_IMAGE: 'getAssetChartImage',
  GET_APP_STORAGE_DATA: 'getAppStorageData',
  DISPATCH_UPDATE_EVENT: 'dispatchUpdateEvent',
  SET_APP_STORAGE_DATA: 'setAppStorageData',
  ACTIVATE_PULL_TO_REFRESH: 'activatePullToRefresh',
  COMPLETE_PULL_TO_REFRESH: 'completePullToRefresh',
  SET_DEVICE_BACK: 'setDeviceBack',
  CLOSE_AND_MOVE: 'closeAndMove',
  OPEN_URL: 'openUrl',
  SET_OVER_SCROLL: 'setOverScroll',
  SET_ENTIRE_SWIPE_BACK: 'setEntireSwipeBack',
  POST_BRAZE_EVENT: 'postBrazeEvent',
  POST_BRAZE_USER_ATTRIBUTE: 'postBrazeUserAttribute',
  SHOW_POST_TAG_FILTER_BOTTOM_SHEET: 'showPostTagFilterBottomSheet',
  HALF_VIEW: 'halfView',
  IS_AVAILABLE_FUNCTION: 'isAvailableFunction',
  SHOW_FOLLOWING_BOTTOM_SHEET_IF_FIRST: 'showFollowingBottomSheetIfFirst',
  EXPAND_TOOLBAR: 'expandToolbar',
  COLLAPSE_TOOLBAR: 'collapseToolbar',
  GET_INVESTMENT_LEVEL_IMAGE: 'getInvestmentLevelImage',
  HIDE_POST_WRITE_BUTTON: 'hidePostWriteButton',
  GET_ATTACHMENT_ITEMS: 'getAttachmentItems',
  RELOAD: 'reload',
  READY: 'ready',
  SHOW_USER_TERMS_AGREEMENT: 'showUserTermsAgreement'
};

var AndroidBridgeInterface = /*#__PURE__*/function () {
  function AndroidBridgeInterface(_ref) {
    var runner = _ref.runner,
      eventBus = _ref.eventBus;
    _classCallCheck(this, AndroidBridgeInterface);
    this.appStorageEventDistributor = new EventDistributor();
    if (!runner) {
      throw new Error('AndroidBridgeInterface: runner is undefined');
    }
    if (!eventBus) {
      throw new Error('AndroidBridgeInterface: eventBus is undefined');
    }
    this.runner = runner;
    this.eventBus = eventBus;
    this.eventBus.on(APP_TO_WEB_EVENT.SEND_APP_STORAGE_DATA, this.appStorageEventDistributor.dispatch);
  }
  _createClass(AndroidBridgeInterface, [{
    key: "getToken",
    value: function getToken(isRefresh) {
      var _this = this;
      return new _Promise(function (resolve) {
        _this.eventBus.once(APP_TO_WEB_EVENT.SET_TOKEN, function (token) {
          resolve(token);
        });
        _this.runner[BRIDGE_INTERFACE.GET_TOKEN](isRefresh);
      });
    }
  }, {
    key: "getQuotationToken",
    value: function getQuotationToken(isRefresh) {
      var _this2 = this;
      return new _Promise(function (resolve) {
        _this2.eventBus.once(APP_TO_WEB_EVENT.SET_QUOTATION_TOKEN, function (token) {
          resolve(token);
        });
        _this2.runner[BRIDGE_INTERFACE.GET_QUOTATION_TOKEN](isRefresh);
      });
    }
  }, {
    key: "close",
    value: function close() {
      this.runner[BRIDGE_INTERFACE.CLOSE]();
    }
  }, {
    key: "showToast",
    value: function showToast(message) {
      this.runner[BRIDGE_INTERFACE.SHOW_TOAST](message);
    }
  }, {
    key: "syncAccount",
    value: function syncAccount() {
      this.runner[BRIDGE_INTERFACE.SYNC_ACCOUNT]();
    }
  }, {
    key: "onUpdateState",
    value: function onUpdateState(state) {
      this.runner[BRIDGE_INTERFACE.ON_UPDATE_STATE](state);
    }
  }, {
    key: "trackEvent",
    value: function trackEvent(eventProperties) {
      var page = eventProperties.page,
        event = eventProperties.event,
        eventDetail = eventProperties.eventDetail,
        pageDetail = eventProperties.pageDetail;
      this.runner[BRIDGE_INTERFACE.TRACK_EVENT](page, event, eventDetail, pageDetail);
    }
  }, {
    key: "postAmplitudeEvent",
    value: function postAmplitudeEvent(eventProperties) {
      var event = eventProperties.event,
        data = __rest(eventProperties, ["event"]);
      this.runner[BRIDGE_INTERFACE.POST_AMPLITUDE_EVENT](event, _JSON$stringify(data));
    }
  }, {
    key: "securityAccountSync",
    value: function securityAccountSync() {
      this.runner[BRIDGE_INTERFACE.SECURITY_ACCOUNT_SYNC]();
    }
  }, {
    key: "changeTitle",
    value: function changeTitle(title) {
      this.runner[BRIDGE_INTERFACE.CHANGE_TITLE](title);
    }
  }, {
    key: "pagePush",
    value: function pagePush(url) {
      this.runner[BRIDGE_INTERFACE.PAGE_PUSH](url);
    }
  }, {
    key: "selectedGroup",
    value: function selectedGroup(groupId) {
      this.runner[BRIDGE_INTERFACE.SELECTED_GROUP](groupId);
    }
  }, {
    key: "showGroupStockLists",
    value: function showGroupStockLists(groupId) {
      this.runner[BRIDGE_INTERFACE.SHOW_GROUP_STOCK_LISTS](groupId);
    }
  }, {
    key: "showEmptyStockAnalyzeReport",
    value: function showEmptyStockAnalyzeReport() {
      this.runner[BRIDGE_INTERFACE.SHOW_EMPTY_STOCK_ANALYZE_REPORT]();
    }
  }, {
    key: "stockAnalyzeRegistStock",
    value: function stockAnalyzeRegistStock() {
      this.runner[BRIDGE_INTERFACE.STOCK_ANALYZE_REGIST_STOCK]();
    }
  }, {
    key: "topMenuVisible",
    value: function topMenuVisible(visible) {
      this.runner[BRIDGE_INTERFACE.TOP_MENU_VISIBLE](visible);
    }
  }, {
    key: "getFavoriteGroupInfos",
    value: function getFavoriteGroupInfos(type) {
      var _this3 = this;
      return new _Promise(function (resolve) {
        _this3.eventBus.once(APP_TO_WEB_EVENT.SEND_GROUP_INFOS, function (infos) {
          resolve(infos);
        });
        _this3.runner[BRIDGE_INTERFACE.GET_FAVORITE_GROUP_INFOS](type);
      });
    }
  }, {
    key: "share",
    value: function share(message) {
      this.runner[BRIDGE_INTERFACE.SHARE](message);
    }
  }, {
    key: "getUserInfo",
    value: function getUserInfo() {
      var _this4 = this;
      return new _Promise(function (resolve) {
        _this4.eventBus.once(APP_TO_WEB_EVENT.SEND_USER_INFO, function (info) {
          resolve(info);
        });
        _this4.runner[BRIDGE_INTERFACE.GET_USER_INFO]();
      });
    }
  }, {
    key: "getAppInfo",
    value: function getAppInfo() {
      var _this5 = this;
      return new _Promise(function (resolve) {
        _this5.eventBus.once(APP_TO_WEB_EVENT.SEND_APP_INFO, function (info) {
          resolve(info);
        });
        _this5.runner[BRIDGE_INTERFACE.GET_APP_INFO]();
      });
    }
  }, {
    key: "pageLoadClearHistory",
    value: function pageLoadClearHistory(url) {
      this.runner[BRIDGE_INTERFACE.PAGE_LOAD_CLEAR_HISTORY](url);
    }
  }, {
    key: "upbitLink",
    value: function upbitLink() {
      this.runner[BRIDGE_INTERFACE.UPBIT_LINK]();
    }
  }, {
    key: "getAlarmState",
    value: function getAlarmState() {
      var _this6 = this;
      return new _Promise(function (resolve) {
        _this6.eventBus.once(APP_TO_WEB_EVENT.SET_ALARM_STATE, function (isTurnOn) {
          resolve(isTurnOn);
        });
        _this6.runner[BRIDGE_INTERFACE.GET_ALARM_STATE]();
      });
    }
  }, {
    key: "landingSetting",
    value: function landingSetting() {
      this.runner[BRIDGE_INTERFACE.LANDING_SETTING]();
    }
  }, {
    key: "postAppsflyerEvent",
    value: function postAppsflyerEvent(eventProperties) {
      var event = eventProperties.event,
        data = __rest(eventProperties, ["event"]);
      this.runner[BRIDGE_INTERFACE.POST_APPSFLYER_EVENT](event, _JSON$stringify(data));
    }
  }, {
    key: "setWebContentHeight",
    value: function setWebContentHeight(height) {
      this.runner[BRIDGE_INTERFACE.SET_WEB_CONTENT_HEIGHT](height);
    }
  }, {
    key: "getFontSizeLevel",
    value: function getFontSizeLevel() {
      var _this7 = this;
      return new _Promise(function (resolve) {
        _this7.eventBus.once(APP_TO_WEB_EVENT.SET_FONT_SIZE_LEVEL, function (level) {
          resolve(level);
        });
        _this7.runner[BRIDGE_INTERFACE.GET_FONT_SIZE_LEVEL]();
      });
    }
  }, {
    key: "getEmergencySkip",
    value: function getEmergencySkip() {
      var _this8 = this;
      return new _Promise(function (resolve) {
        _this8.eventBus.once(APP_TO_WEB_EVENT.SET_EMERGENCY_SKIP, function (isTurnOn) {
          resolve(isTurnOn);
        });
        _this8.runner[BRIDGE_INTERFACE.GET_EMERGENCY_SKIP]();
      });
    }
  }, {
    key: "calendarAddGroup",
    value: function calendarAddGroup(id, name) {
      this.runner[BRIDGE_INTERFACE.CALENDAR_ADD_GROUP](id, name);
    }
  }, {
    key: "completeVerification",
    value: function completeVerification() {
      this.runner[BRIDGE_INTERFACE.COMPLETE_VERIFICATION]();
    }
  }, {
    key: "moveToMain",
    value: function moveToMain() {
      this.runner[BRIDGE_INTERFACE.MOVE_TO_MAIN]();
    }
  }, {
    key: "enableResizeByKeyboard",
    value: function enableResizeByKeyboard(_enableResizeByKeyboard) {
      this.runner[BRIDGE_INTERFACE.ENABLE_RESIZE_BY_KEYBOARD]();
    }
  }, {
    key: "showPostWriteButton",
    value: function showPostWriteButton(scheme) {
      this.runner[BRIDGE_INTERFACE.SHOW_POST_WRITE_BUTTON](scheme);
    }
  }, {
    key: "getAssetChartImage",
    value: function getAssetChartImage(assetCode) {
      this.runner[BRIDGE_INTERFACE.GET_ASSET_CHART_IMAGE](assetCode || []);
    }
  }, {
    key: "getAppStorageData",
    value: function getAppStorageData(key) {
      var _this9 = this;
      return new _Promise(function (resolve) {
        _this9.appStorageEventDistributor.once(key, function (value) {
          resolve({
            key: key,
            value: value
          });
        });
        _this9.runner[BRIDGE_INTERFACE.GET_APP_STORAGE_DATA](key);
      });
    }
  }, {
    key: "dispatchUpdateEvent",
    value: function dispatchUpdateEvent(key, data) {
      this.runner[BRIDGE_INTERFACE.DISPATCH_UPDATE_EVENT](key, data);
    }
  }, {
    key: "setAppStorageData",
    value: function setAppStorageData(key, value) {
      this.runner[BRIDGE_INTERFACE.SET_APP_STORAGE_DATA](key, value);
    }
  }, {
    key: "activatePullToRefresh",
    value: function activatePullToRefresh(isHandleByWeb) {
      this.runner[BRIDGE_INTERFACE.ACTIVATE_PULL_TO_REFRESH](isHandleByWeb);
    }
  }, {
    key: "completePullToRefresh",
    value: function completePullToRefresh() {
      this.runner[BRIDGE_INTERFACE.COMPLETE_PULL_TO_REFRESH]();
    }
  }, {
    key: "setDeviceBack",
    value: function setDeviceBack(enable) {
      this.runner[BRIDGE_INTERFACE.SET_DEVICE_BACK](enable);
    }
  }, {
    key: "closeAndMove",
    value: function closeAndMove(scheme) {
      this.runner[BRIDGE_INTERFACE.CLOSE_AND_MOVE](scheme);
    }
  }, {
    key: "openUrl",
    value: function openUrl(url) {
      this.runner[BRIDGE_INTERFACE.OPEN_URL](url);
    }
  }, {
    key: "setOverScroll",
    value: function setOverScroll(enable) {
      this.runner[BRIDGE_INTERFACE.SET_OVER_SCROLL](enable);
    }
  }, {
    key: "setEntireSwipeBack",
    value: function setEntireSwipeBack(_enable) {
      // do nothing
    }
  }, {
    key: "postBrazeEvent",
    value: function postBrazeEvent(_ref2) {
      var _context;
      var name = _ref2.name,
        properties = _ref2.properties,
        dateProperties = _ref2.dateProperties;
      var _a, _b;
      var dateStringProperties = dateProperties ? _reduceInstanceProperty(_context = _Object$entries(dateProperties)).call(_context, function (prev, _ref3) {
        var _ref4 = _slicedToArray(_ref3, 2),
          key = _ref4[0],
          value = _ref4[1];
        prev[key] = value.getTime().toString();
        return prev;
      }, {}) : null;
      (_b = (_a = this.runner)[BRIDGE_INTERFACE.POST_BRAZE_EVENT]) === null || _b === void 0 ? void 0 : _b.call(_a, name, properties ? _JSON$stringify(properties) : null, dateProperties ? _JSON$stringify(dateStringProperties) : null);
    }
  }, {
    key: "postBrazeUserAttribute",
    value: function postBrazeUserAttribute(eventProperties) {
      var _a, _b, _c, _d;
      if ('value' in eventProperties) {
        (_b = (_a = this.runner)[BRIDGE_INTERFACE.POST_BRAZE_USER_ATTRIBUTE]) === null || _b === void 0 ? void 0 : _b.call(_a, eventProperties.key, eventProperties.value, null);
      } else {
        (_d = (_c = this.runner)[BRIDGE_INTERFACE.POST_BRAZE_USER_ATTRIBUTE]) === null || _d === void 0 ? void 0 : _d.call(_c, eventProperties.key, null, eventProperties.dateValue.getTime().toString());
      }
    }
  }, {
    key: "showPostTagFilterBottomSheet",
    value: function showPostTagFilterBottomSheet(_ref5) {
      var spUid = _ref5.spUid,
        _ref5$selectedTag = _ref5.selectedTag,
        selectedTag = _ref5$selectedTag === void 0 ? null : _ref5$selectedTag;
      this.runner[BRIDGE_INTERFACE.SHOW_POST_TAG_FILTER_BOTTOM_SHEET](spUid, selectedTag);
    }
  }, {
    key: "halfView",
    value: function halfView(_ref6) {
      var type = _ref6.type,
        url = _ref6.url,
        title = _ref6.title,
        height = _ref6.height,
        subtitle = _ref6.subtitle;
      this.runner[BRIDGE_INTERFACE.HALF_VIEW](url, title, subtitle !== null && subtitle !== void 0 ? subtitle : null, height, type);
    }
  }, {
    key: "isAvailableFunction",
    value: function isAvailableFunction(name) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", name in this.runner);
            case 1:
            case "end":
              return _context2.stop();
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "showFollowingBottomSheetIfFirst",
    value: function showFollowingBottomSheetIfFirst(params) {
      this.runner[BRIDGE_INTERFACE.SHOW_FOLLOWING_BOTTOM_SHEET_IF_FIRST](params.type, params.name, params.key);
    }
  }, {
    key: "expandToolbar",
    value: function expandToolbar() {
      this.runner[BRIDGE_INTERFACE.EXPAND_TOOLBAR]();
    }
  }, {
    key: "collapseToolbar",
    value: function collapseToolbar() {
      this.runner[BRIDGE_INTERFACE.COLLAPSE_TOOLBAR]();
    }
  }, {
    key: "getInvestmentLevelImage",
    value: function getInvestmentLevelImage() {
      this.runner[BRIDGE_INTERFACE.GET_INVESTMENT_LEVEL_IMAGE]();
    }
  }, {
    key: "hidePostWriteButton",
    value: function hidePostWriteButton() {
      this.runner[BRIDGE_INTERFACE.HIDE_POST_WRITE_BUTTON]();
    }
  }, {
    key: "getAttachmentItems",
    value: function getAttachmentItems() {
      this.runner[BRIDGE_INTERFACE.GET_ATTACHMENT_ITEMS]();
    }
  }, {
    key: "reload",
    value: function reload() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var isSupportReload;
        return _regeneratorRuntime.wrap(function _callee2$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return this.isAvailableFunction('reload');
            case 2:
              isSupportReload = _context3.sent;
              if (isSupportReload) {
                this.runner[BRIDGE_INTERFACE.RELOAD]();
              } else {
                location.reload();
              }
            case 4:
            case "end":
              return _context3.stop();
          }
        }, _callee2, this);
      }));
    }
  }, {
    key: "ready",
    value: function ready() {
      this.runner[BRIDGE_INTERFACE.READY]();
    }
  }, {
    key: "showUserTermsAgreement",
    value: function showUserTermsAgreement(key, redirectUrl) {
      this.runner[BRIDGE_INTERFACE.SHOW_USER_TERMS_AGREEMENT](key, redirectUrl);
    }
  }]);
  return AndroidBridgeInterface;
}();

var AppToWebBridgeInterface = /*#__PURE__*/function () {
  function AppToWebBridgeInterface(eventBus) {
    _classCallCheck(this, AppToWebBridgeInterface);
    this.eventBus = eventBus;
    if (!eventBus) {
      throw new Error('EventBus is required.');
    }
  }
  _createClass(AppToWebBridgeInterface, [{
    key: "setToken",
    value: function setToken(token) {
      var _a;
      if (!token) {
        throw new Error('Token is empty');
      }
      (_a = this.eventBus) === null || _a === void 0 ? void 0 : _a.dispatch(APP_TO_WEB_EVENT.SET_TOKEN, token);
    }
  }, {
    key: "setQuotationToken",
    value: function setQuotationToken(token) {
      var _a;
      if (!token) {
        throw new Error('Token is empty');
      }
      (_a = this.eventBus) === null || _a === void 0 ? void 0 : _a.dispatch(APP_TO_WEB_EVENT.SET_QUOTATION_TOKEN, token);
    }
  }, {
    key: "sendBackKey",
    value: function sendBackKey() {
      var _a;
      (_a = this.eventBus) === null || _a === void 0 ? void 0 : _a.dispatch(APP_TO_WEB_EVENT.SEND_BACK_KEY);
    }
  }, {
    key: "sendGroupInfos",
    value: function sendGroupInfos(infos) {
      var _a;
      (_a = this.eventBus) === null || _a === void 0 ? void 0 : _a.dispatch(APP_TO_WEB_EVENT.SEND_GROUP_INFOS, infos);
    }
  }, {
    key: "sendUserInfo",
    value: function sendUserInfo(userId) {
      var _a;
      (_a = this.eventBus) === null || _a === void 0 ? void 0 : _a.dispatch(APP_TO_WEB_EVENT.SEND_USER_INFO, userId);
    }
  }, {
    key: "sendAppInfo",
    value: function sendAppInfo(appInfo) {
      var _a;
      (_a = this.eventBus) === null || _a === void 0 ? void 0 : _a.dispatch(APP_TO_WEB_EVENT.SEND_APP_INFO, appInfo);
    }
  }, {
    key: "setAlarmState",
    value: function setAlarmState(isTurnOn) {
      var _a;
      (_a = this.eventBus) === null || _a === void 0 ? void 0 : _a.dispatch(APP_TO_WEB_EVENT.SET_ALARM_STATE, isTurnOn);
    }
  }, {
    key: "setFontSizeLevel",
    value: function setFontSizeLevel(level) {
      var _a;
      (_a = this.eventBus) === null || _a === void 0 ? void 0 : _a.dispatch(APP_TO_WEB_EVENT.SET_FONT_SIZE_LEVEL, level);
    }
  }, {
    key: "setEmergencySkip",
    value: function setEmergencySkip(isTurnOn) {
      var _a;
      (_a = this.eventBus) === null || _a === void 0 ? void 0 : _a.dispatch(APP_TO_WEB_EVENT.SET_EMERGENCY_SKIP, isTurnOn);
    }
  }, {
    key: "sendClickShared",
    value: function sendClickShared() {
      var _a;
      (_a = this.eventBus) === null || _a === void 0 ? void 0 : _a.dispatch(APP_TO_WEB_EVENT.SEND_CLICK_SHARED);
    }
  }, {
    key: "setAssetChartImage",
    value: function setAssetChartImage(imageData) {
      var _a;
      (_a = this.eventBus) === null || _a === void 0 ? void 0 : _a.dispatch(APP_TO_WEB_EVENT.SET_ASSET_CHART_IMAGE, imageData);
    }
  }, {
    key: "sendAppStorageData",
    value: function sendAppStorageData(key, value) {
      var _a;
      (_a = this.eventBus) === null || _a === void 0 ? void 0 : _a.dispatch(APP_TO_WEB_EVENT.SEND_APP_STORAGE_DATA, key, value);
    }
  }, {
    key: "sendWebVisible",
    value: function sendWebVisible(isVisible) {
      var _a;
      (_a = this.eventBus) === null || _a === void 0 ? void 0 : _a.dispatch(APP_TO_WEB_EVENT.SEND_WEB_VISIBLE, isVisible);
    }
    /**
     * 앱에서 당겨서 새로고침이 발생했을 때 이 함수를 호출
     */
  }, {
    key: "sendPullToRefresh",
    value: function sendPullToRefresh() {
      var _a;
      (_a = this.eventBus) === null || _a === void 0 ? void 0 : _a.dispatch(APP_TO_WEB_EVENT.SEND_PULL_TO_REFRESH);
    }
    /**
     * UI가 펼치고 접힌 정도를 0~1 사이의 숫자로 전달
     */
  }, {
    key: "sendExpandingProgress",
    value: function sendExpandingProgress(weight) {
      var _a;
      (_a = this.eventBus) === null || _a === void 0 ? void 0 : _a.dispatch(APP_TO_WEB_EVENT.SEND_EXPANDING_PROGRESS, weight);
    }
  }, {
    key: "setPostTagFilter",
    value: function setPostTagFilter(assetKey, assetName) {
      var _a;
      (_a = this.eventBus) === null || _a === void 0 ? void 0 : _a.dispatch(APP_TO_WEB_EVENT.SET_POST_TAG_FILTER, assetKey, assetName);
    }
  }, {
    key: "setIsAvailableFunction",
    value: function setIsAvailableFunction(name, isAvailable) {
      var _a;
      (_a = this.eventBus) === null || _a === void 0 ? void 0 : _a.dispatch(APP_TO_WEB_EVENT.SET_IS_AVAILABLE_FUNCTION, name, isAvailable);
    }
  }, {
    key: "sendScrollTop",
    value: function sendScrollTop() {
      var _a;
      (_a = this.eventBus) === null || _a === void 0 ? void 0 : _a.dispatch(APP_TO_WEB_EVENT.SEND_SCROLL_TOP);
    }
    /**
     * @param url 이미지 업로드가 실패했을 때 null을 전달
     */
  }, {
    key: "setInvestmentLevelImage",
    value: function setInvestmentLevelImage(imageData) {
      var _a;
      (_a = this.eventBus) === null || _a === void 0 ? void 0 : _a.dispatch(APP_TO_WEB_EVENT.SET_INVESTMENT_LEVEL_IMAGE, imageData);
    }
  }, {
    key: "sendClickPostWrite",
    value: function sendClickPostWrite() {
      var _a;
      (_a = this.eventBus) === null || _a === void 0 ? void 0 : _a.dispatch(APP_TO_WEB_EVENT.SEND_CLICK_POST_WRITE);
    }
  }, {
    key: "setAttachmentItems",
    value: function setAttachmentItems(items) {
      var _a;
      (_a = this.eventBus) === null || _a === void 0 ? void 0 : _a.dispatch(APP_TO_WEB_EVENT.SET_ATTACHMENT_ITEMS, items);
    }
  }, {
    key: "sendEnterCommunity",
    value: function sendEnterCommunity() {
      var _a;
      (_a = this.eventBus) === null || _a === void 0 ? void 0 : _a.dispatch(APP_TO_WEB_EVENT.SEND_ENTER_COMMUNITY);
    }
  }]);
  return AppToWebBridgeInterface;
}();

var BrowserBridgeInterface = /*#__PURE__*/function () {
  function BrowserBridgeInterface(_ref) {
    var runner = _ref.runner,
      eventBus = _ref.eventBus;
    _classCallCheck(this, BrowserBridgeInterface);
    this.appStorageEventDistributor = new EventDistributor();
    if (!eventBus) {
      throw new Error('BrowserBridgeInterface: eventBus is undefined');
    }
    if (runner) {
      this.runner = runner;
    }
    this.eventBus = eventBus;
    this.eventBus.on(APP_TO_WEB_EVENT.SEND_APP_STORAGE_DATA, this.appStorageEventDistributor.dispatch);
  }
  _createClass(BrowserBridgeInterface, [{
    key: "getToken",
    value: function getToken(isRefresh) {
      var _this = this;
      return new _Promise(function (resolve) {
        _this.eventBus.once(APP_TO_WEB_EVENT.SET_TOKEN, function (token) {
          resolve(token);
        });
        if (_this.runner) {
          _this.runner[BRIDGE_INTERFACE.GET_TOKEN](isRefresh);
        } else {
          resolve(null);
        }
      });
    }
  }, {
    key: "getQuotationToken",
    value: function getQuotationToken(isRefresh) {
      var _this2 = this;
      return new _Promise(function (resolve) {
        _this2.eventBus.once(APP_TO_WEB_EVENT.SET_QUOTATION_TOKEN, function (token) {
          resolve(token);
        });
        if (_this2.runner) {
          _this2.runner[BRIDGE_INTERFACE.GET_QUOTATION_TOKEN](isRefresh);
        } else {
          resolve(null);
        }
      });
    }
  }, {
    key: "close",
    value: function close() {
      if (this.runner) {
        this.runner[BRIDGE_INTERFACE.CLOSE]();
      }
    }
  }, {
    key: "showToast",
    value: function showToast(message) {
      if (this.runner) {
        this.runner[BRIDGE_INTERFACE.SHOW_TOAST](message);
      }
    }
  }, {
    key: "syncAccount",
    value: function syncAccount() {
      if (this.runner) {
        this.runner[BRIDGE_INTERFACE.SYNC_ACCOUNT]();
      }
    }
  }, {
    key: "onUpdateState",
    value: function onUpdateState(state) {
      if (this.runner) {
        this.runner[BRIDGE_INTERFACE.ON_UPDATE_STATE](state);
      }
    }
  }, {
    key: "trackEvent",
    value: function trackEvent(eventProperties) {
      var page = eventProperties.page,
        event = eventProperties.event,
        eventDetail = eventProperties.eventDetail,
        pageDetail = eventProperties.pageDetail;
      if (this.runner) {
        this.runner[BRIDGE_INTERFACE.TRACK_EVENT](page, event, eventDetail, pageDetail);
      }
    }
  }, {
    key: "postAmplitudeEvent",
    value: function postAmplitudeEvent(eventProperties) {
      var event = eventProperties.event,
        data = __rest(eventProperties, ["event"]);
      if (this.runner) {
        this.runner[BRIDGE_INTERFACE.POST_AMPLITUDE_EVENT](event, data);
      }
    }
  }, {
    key: "securityAccountSync",
    value: function securityAccountSync() {
      if (this.runner) {
        this.runner[BRIDGE_INTERFACE.SECURITY_ACCOUNT_SYNC]();
      }
    }
  }, {
    key: "changeTitle",
    value: function changeTitle(title) {
      if (this.runner) {
        this.runner[BRIDGE_INTERFACE.CHANGE_TITLE](title);
      }
    }
  }, {
    key: "pagePush",
    value: function pagePush(url) {
      if (this.runner) {
        this.runner[BRIDGE_INTERFACE.PAGE_PUSH](url);
      }
    }
  }, {
    key: "selectedGroup",
    value: function selectedGroup(groupId) {
      if (this.runner) {
        this.runner[BRIDGE_INTERFACE.SELECTED_GROUP](groupId);
      }
    }
  }, {
    key: "showGroupStockLists",
    value: function showGroupStockLists(groupId) {
      if (this.runner) {
        this.runner[BRIDGE_INTERFACE.SHOW_GROUP_STOCK_LISTS](groupId);
      }
    }
  }, {
    key: "showEmptyStockAnalyzeReport",
    value: function showEmptyStockAnalyzeReport() {
      if (this.runner) {
        this.runner[BRIDGE_INTERFACE.SHOW_EMPTY_STOCK_ANALYZE_REPORT]();
      }
    }
  }, {
    key: "stockAnalyzeRegistStock",
    value: function stockAnalyzeRegistStock() {
      if (this.runner) {
        this.runner[BRIDGE_INTERFACE.STOCK_ANALYZE_REGIST_STOCK]();
      }
    }
  }, {
    key: "topMenuVisible",
    value: function topMenuVisible(visible) {
      if (this.runner) {
        this.runner[BRIDGE_INTERFACE.TOP_MENU_VISIBLE](visible);
      }
    }
  }, {
    key: "getFavoriteGroupInfos",
    value: function getFavoriteGroupInfos(type) {
      var _this3 = this;
      return new _Promise(function (resolve) {
        _this3.eventBus.once(APP_TO_WEB_EVENT.SEND_GROUP_INFOS, function (infos) {
          resolve(infos);
        });
        if (_this3.runner) {
          _this3.runner[BRIDGE_INTERFACE.GET_FAVORITE_GROUP_INFOS](type);
        } else {
          resolve(null);
        }
      });
    }
  }, {
    key: "share",
    value: function share(message) {
      if (this.runner) {
        this.runner[BRIDGE_INTERFACE.SHARE](message);
      }
    }
  }, {
    key: "getUserInfo",
    value: function getUserInfo() {
      var _this4 = this;
      return new _Promise(function (resolve) {
        _this4.eventBus.once(APP_TO_WEB_EVENT.SEND_USER_INFO, function (info) {
          resolve(info);
        });
        if (_this4.runner) {
          _this4.runner[BRIDGE_INTERFACE.GET_USER_INFO]();
        } else {
          resolve(null);
        }
      });
    }
  }, {
    key: "getAppInfo",
    value: function getAppInfo() {
      var _this5 = this;
      return new _Promise(function (resolve) {
        _this5.eventBus.once(APP_TO_WEB_EVENT.SEND_APP_INFO, function (info) {
          resolve(info);
        });
        if (_this5.runner) {
          _this5.runner[BRIDGE_INTERFACE.GET_APP_INFO]();
        } else {
          resolve(null);
        }
      });
    }
  }, {
    key: "pageLoadClearHistory",
    value: function pageLoadClearHistory(url) {
      if (this.runner) {
        this.runner[BRIDGE_INTERFACE.PAGE_LOAD_CLEAR_HISTORY](url);
      }
    }
  }, {
    key: "upbitLink",
    value: function upbitLink() {
      if (this.runner) {
        this.runner[BRIDGE_INTERFACE.UPBIT_LINK]();
      }
    }
  }, {
    key: "getAlarmState",
    value: function getAlarmState() {
      var _this6 = this;
      return new _Promise(function (resolve) {
        _this6.eventBus.once(APP_TO_WEB_EVENT.SET_ALARM_STATE, function (alarmState) {
          resolve(alarmState);
        });
        if (_this6.runner) {
          _this6.runner[BRIDGE_INTERFACE.GET_ALARM_STATE]();
        } else {
          resolve(null);
        }
      });
    }
  }, {
    key: "landingSetting",
    value: function landingSetting() {
      if (this.runner) {
        this.runner[BRIDGE_INTERFACE.LANDING_SETTING]();
      }
    }
  }, {
    key: "postAppsflyerEvent",
    value: function postAppsflyerEvent(eventProperties) {
      var event = eventProperties.event,
        data = __rest(eventProperties, ["event"]);
      if (this.runner) {
        this.runner[BRIDGE_INTERFACE.POST_APPSFLYER_EVENT](event, data);
      }
    }
  }, {
    key: "setWebContentHeight",
    value: function setWebContentHeight(height) {
      if (this.runner) {
        this.runner[BRIDGE_INTERFACE.SET_WEB_CONTENT_HEIGHT](height);
      }
    }
  }, {
    key: "getFontSizeLevel",
    value: function getFontSizeLevel() {
      var _this7 = this;
      return new _Promise(function (resolve) {
        _this7.eventBus.once(APP_TO_WEB_EVENT.SET_FONT_SIZE_LEVEL, function (level) {
          resolve(level);
        });
        if (_this7.runner) {
          _this7.runner[BRIDGE_INTERFACE.GET_FONT_SIZE_LEVEL]();
        } else {
          var DEFAULT_LEVEL = 3;
          resolve(DEFAULT_LEVEL);
        }
      });
    }
  }, {
    key: "getEmergencySkip",
    value: function getEmergencySkip() {
      var _this8 = this;
      return new _Promise(function (resolve) {
        if (_this8.runner) {
          _this8.eventBus.once(APP_TO_WEB_EVENT.SET_EMERGENCY_SKIP, function (isTurnOn) {
            resolve(isTurnOn);
          });
          _this8.runner[BRIDGE_INTERFACE.GET_EMERGENCY_SKIP]();
        } else {
          resolve(false);
        }
      });
    }
  }, {
    key: "calendarAddGroup",
    value: function calendarAddGroup(id, name) {
      if (this.runner) {
        this.runner[BRIDGE_INTERFACE.CALENDAR_ADD_GROUP](id, name);
      }
    }
  }, {
    key: "completeVerification",
    value: function completeVerification() {
      if (this.runner) {
        this.runner[BRIDGE_INTERFACE.COMPLETE_VERIFICATION]();
      }
    }
  }, {
    key: "moveToMain",
    value: function moveToMain() {
      if (this.runner) {
        this.runner[BRIDGE_INTERFACE.MOVE_TO_MAIN]();
      }
    }
  }, {
    key: "enableResizeByKeyboard",
    value: function enableResizeByKeyboard(_enableResizeByKeyboard) {
      if (this.runner) {
        this.runner[BRIDGE_INTERFACE.ENABLE_RESIZE_BY_KEYBOARD]();
      }
    }
  }, {
    key: "showPostWriteButton",
    value: function showPostWriteButton(scheme) {
      if (this.runner) {
        this.runner[BRIDGE_INTERFACE.SHOW_POST_WRITE_BUTTON](scheme);
      }
    }
  }, {
    key: "getAssetChartImage",
    value: function getAssetChartImage(assetCode) {
      if (this.runner) {
        this.runner[BRIDGE_INTERFACE.GET_ASSET_CHART_IMAGE](assetCode || []);
      }
    }
  }, {
    key: "getAppStorageData",
    value: function getAppStorageData(key) {
      var _this9 = this;
      return new _Promise(function (resolve) {
        _this9.appStorageEventDistributor.once(key, function (value) {
          resolve({
            key: key,
            value: value
          });
        });
        if (_this9.runner) {
          _this9.runner[BRIDGE_INTERFACE.GET_APP_STORAGE_DATA](key);
        } else {
          resolve(null);
        }
      });
    }
  }, {
    key: "dispatchUpdateEvent",
    value: function dispatchUpdateEvent(key, data) {
      if (this.runner) {
        this.runner[BRIDGE_INTERFACE.DISPATCH_UPDATE_EVENT](key, data);
      }
    }
  }, {
    key: "setAppStorageData",
    value: function setAppStorageData(key, value) {
      if (this.runner) {
        this.runner[BRIDGE_INTERFACE.SET_APP_STORAGE_DATA](key, value);
      }
    }
  }, {
    key: "activatePullToRefresh",
    value: function activatePullToRefresh(isHandleByWeb) {
      if (this.runner) {
        this.runner[BRIDGE_INTERFACE.ACTIVATE_PULL_TO_REFRESH](isHandleByWeb);
      }
    }
  }, {
    key: "completePullToRefresh",
    value: function completePullToRefresh() {
      if (this.runner) {
        this.runner[BRIDGE_INTERFACE.COMPLETE_PULL_TO_REFRESH]();
      }
    }
  }, {
    key: "setDeviceBack",
    value: function setDeviceBack(enable) {
      if (this.runner) {
        this.runner[BRIDGE_INTERFACE.SET_DEVICE_BACK](enable);
      }
    }
  }, {
    key: "closeAndMove",
    value: function closeAndMove(scheme) {
      if (this.runner) {
        this.runner[BRIDGE_INTERFACE.CLOSE_AND_MOVE](scheme);
      }
    }
  }, {
    key: "openUrl",
    value: function openUrl(url) {
      if (this.runner) {
        this.runner[BRIDGE_INTERFACE.OPEN_URL](url);
      }
    }
  }, {
    key: "setOverScroll",
    value: function setOverScroll(enable) {
      if (this.runner) {
        this.runner[BRIDGE_INTERFACE.SET_OVER_SCROLL](enable);
      }
    }
  }, {
    key: "setEntireSwipeBack",
    value: function setEntireSwipeBack(_enable) {
      // do nothing
    }
  }, {
    key: "postBrazeEvent",
    value: function postBrazeEvent(_ref2) {
      var name = _ref2.name,
        properties = _ref2.properties,
        dateProperties = _ref2.dateProperties;
      if (this.runner) {
        this.runner[BRIDGE_INTERFACE.POST_BRAZE_EVENT](name, properties, dateProperties);
      }
    }
  }, {
    key: "postBrazeUserAttribute",
    value: function postBrazeUserAttribute(eventProperties) {
      if (!this.runner) {
        return;
      }
      if ('value' in eventProperties) {
        this.runner[BRIDGE_INTERFACE.POST_BRAZE_USER_ATTRIBUTE](eventProperties.key, eventProperties.value, null);
      } else {
        this.runner[BRIDGE_INTERFACE.POST_BRAZE_USER_ATTRIBUTE](eventProperties.key, null, eventProperties.dateValue.getTime().toString());
      }
    }
  }, {
    key: "showPostTagFilterBottomSheet",
    value: function showPostTagFilterBottomSheet(_ref3) {
      var selectedTag = _ref3.selectedTag,
        spUid = _ref3.spUid;
      if (this.runner) {
        this.runner[BRIDGE_INTERFACE.SHOW_POST_TAG_FILTER_BOTTOM_SHEET](spUid, selectedTag);
      }
    }
  }, {
    key: "halfView",
    value: function halfView(_ref4) {
      var url = _ref4.url,
        title = _ref4.title,
        subtitle = _ref4.subtitle,
        height = _ref4.height,
        type = _ref4.type;
      if (this.runner) {
        this.runner[BRIDGE_INTERFACE.HALF_VIEW](url, title, subtitle, height, type);
      }
    }
  }, {
    key: "isAvailableFunction",
    value: function isAvailableFunction(name) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var runner;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              runner = this.runner || {};
              return _context.abrupt("return", name in runner);
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "showFollowingBottomSheetIfFirst",
    value: function showFollowingBottomSheetIfFirst(_ref5) {
      var type = _ref5.type,
        name = _ref5.name,
        key = _ref5.key;
      if (this.runner) {
        this.runner[BRIDGE_INTERFACE.SHOW_FOLLOWING_BOTTOM_SHEET_IF_FIRST](type, name, key);
      }
    }
  }, {
    key: "expandToolbar",
    value: function expandToolbar() {
      if (this.runner) {
        this.runner[BRIDGE_INTERFACE.EXPAND_TOOLBAR]();
      }
    }
  }, {
    key: "collapseToolbar",
    value: function collapseToolbar() {
      if (this.runner) {
        this.runner[BRIDGE_INTERFACE.COLLAPSE_TOOLBAR]();
      }
    }
  }, {
    key: "getInvestmentLevelImage",
    value: function getInvestmentLevelImage() {
      if (this.runner) {
        this.runner[BRIDGE_INTERFACE.GET_INVESTMENT_LEVEL_IMAGE]();
      }
    }
  }, {
    key: "hidePostWriteButton",
    value: function hidePostWriteButton() {
      if (this.runner) {
        this.runner[BRIDGE_INTERFACE.HIDE_POST_WRITE_BUTTON]();
      }
    }
  }, {
    key: "getAttachmentItems",
    value: function getAttachmentItems() {
      if (this.runner) {
        this.runner[BRIDGE_INTERFACE.GET_ATTACHMENT_ITEMS]();
      }
    }
  }, {
    key: "reload",
    value: function reload() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (this.runner) {
                this.runner[BRIDGE_INTERFACE.RELOAD]();
              } else {
                location.reload();
              }
            case 1:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
    }
  }, {
    key: "ready",
    value: function ready() {
      if (this.runner) {
        this.runner[BRIDGE_INTERFACE.READY]();
      }
    }
  }, {
    key: "showUserTermsAgreement",
    value: function showUserTermsAgreement(key, redirectUrl) {
      if (this.runner) {
        this.runner[BRIDGE_INTERFACE.SHOW_USER_TERMS_AGREEMENT](key, redirectUrl);
      }
    }
  }]);
  return BrowserBridgeInterface;
}();

function _createSuper$1(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$1(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct$1() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var WebviewSDKError = /*#__PURE__*/function (_Error) {
  _inherits(WebviewSDKError, _Error);
  var _super = _createSuper$1(WebviewSDKError);
  function WebviewSDKError(message) {
    _classCallCheck(this, WebviewSDKError);
    return _super.call(this, message);
  }
  _createClass(WebviewSDKError, [{
    key: "name",
    get: function get() {
      return 'WebviewSDKError';
    }
  }]);
  return WebviewSDKError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var TimeoutError = /*#__PURE__*/function (_WebviewSDKError) {
  _inherits(TimeoutError, _WebviewSDKError);
  var _super = _createSuper(TimeoutError);
  function TimeoutError(message) {
    _classCallCheck(this, TimeoutError);
    return _super.call(this, message);
  }
  _createClass(TimeoutError, [{
    key: "name",
    get: function get() {
      return 'TimeoutError';
    }
  }]);
  return TimeoutError;
}(WebviewSDKError);

var timeout = function timeout(ms) {
  return new _Promise(function (_, reject) {
    return _setTimeout(function () {
      return reject(new TimeoutError());
    }, ms);
  });
};
var wait = function wait(ms) {
  return new _Promise(function (resolve) {
    return _setTimeout(resolve, ms);
  });
};
var withTimeout = function withTimeout(promise, ms) {
  return _Promise.race([promise, timeout(ms)]);
};
var waitUntil = function waitUntil(promise, ms) {
  return _Promise.race([promise, wait(ms)]);
};

var IOSBridgeInterface = /*#__PURE__*/function () {
  function IOSBridgeInterface(_ref) {
    var runner = _ref.runner,
      eventBus = _ref.eventBus;
    _classCallCheck(this, IOSBridgeInterface);
    this.appStorageEventDistributor = new EventDistributor();
    this.isAvailableFunctionEventDistributor = new EventDistributor();
    if (!runner) {
      throw new Error('IOSBridgeInterface: bridge is undefined');
    }
    if (!eventBus) {
      throw new Error('IOSBridgeInterface: eventBus is undefined');
    }
    this.runner = runner;
    this.eventBus = eventBus;
    this.eventBus.on(APP_TO_WEB_EVENT.SEND_APP_STORAGE_DATA, this.appStorageEventDistributor.dispatch);
    this.eventBus.on(APP_TO_WEB_EVENT.SET_IS_AVAILABLE_FUNCTION, this.isAvailableFunctionEventDistributor.dispatch);
  }
  _createClass(IOSBridgeInterface, [{
    key: "getToken",
    value: function getToken(isRefresh) {
      var _this = this;
      return new _Promise(function (resolve) {
        _this.eventBus.once(APP_TO_WEB_EVENT.SET_TOKEN, function (token) {
          resolve(token);
        });
        _this.runner({
          "function": BRIDGE_INTERFACE.GET_TOKEN,
          isRefresh: isRefresh
        });
      });
    }
  }, {
    key: "getQuotationToken",
    value: function getQuotationToken(isRefresh) {
      var _this2 = this;
      return new _Promise(function (resolve) {
        _this2.eventBus.once(APP_TO_WEB_EVENT.SET_QUOTATION_TOKEN, function (token) {
          resolve(token);
        });
        _this2.runner({
          "function": BRIDGE_INTERFACE.GET_QUOTATION_TOKEN,
          isRefresh: isRefresh
        });
      });
    }
  }, {
    key: "close",
    value: function close() {
      this.runner({
        "function": BRIDGE_INTERFACE.CLOSE
      });
    }
  }, {
    key: "showToast",
    value: function showToast(message) {
      this.runner({
        "function": BRIDGE_INTERFACE.SHOW_TOAST,
        message: message
      });
    }
  }, {
    key: "syncAccount",
    value: function syncAccount() {
      this.runner({
        "function": BRIDGE_INTERFACE.SYNC_ACCOUNT
      });
    }
  }, {
    key: "onUpdateState",
    value: function onUpdateState(state) {
      this.runner({
        "function": BRIDGE_INTERFACE.ON_UPDATE_STATE,
        state: state
      });
    }
  }, {
    key: "trackEvent",
    value: function trackEvent(eventProperties) {
      this.runner(_Object$assign({
        "function": BRIDGE_INTERFACE.TRACK_EVENT
      }, eventProperties));
    }
  }, {
    key: "postAmplitudeEvent",
    value: function postAmplitudeEvent(eventProperties) {
      var event = eventProperties.event,
        eventData = __rest(eventProperties, ["event"]);
      this.runner({
        "function": BRIDGE_INTERFACE.POST_AMPLITUDE_EVENT,
        event: event,
        properties: eventData
      });
    }
  }, {
    key: "securityAccountSync",
    value: function securityAccountSync() {
      this.runner({
        "function": BRIDGE_INTERFACE.SECURITY_ACCOUNT_SYNC
      });
    }
  }, {
    key: "changeTitle",
    value: function changeTitle(title) {
      this.runner({
        "function": BRIDGE_INTERFACE.CHANGE_TITLE,
        title: title
      });
    }
  }, {
    key: "pagePush",
    value: function pagePush(url) {
      this.runner({
        "function": BRIDGE_INTERFACE.PAGE_PUSH,
        url: url
      });
    }
  }, {
    key: "selectedGroup",
    value: function selectedGroup(groupId) {
      this.runner({
        "function": BRIDGE_INTERFACE.SELECTED_GROUP,
        groupId: groupId
      });
    }
  }, {
    key: "showGroupStockLists",
    value: function showGroupStockLists(groupId) {
      this.runner({
        "function": BRIDGE_INTERFACE.SHOW_GROUP_STOCK_LISTS,
        groupId: groupId
      });
    }
  }, {
    key: "showEmptyStockAnalyzeReport",
    value: function showEmptyStockAnalyzeReport() {
      this.runner({
        "function": BRIDGE_INTERFACE.SHOW_EMPTY_STOCK_ANALYZE_REPORT
      });
    }
  }, {
    key: "stockAnalyzeRegistStock",
    value: function stockAnalyzeRegistStock() {
      this.runner({
        "function": BRIDGE_INTERFACE.STOCK_ANALYZE_REGIST_STOCK
      });
    }
  }, {
    key: "topMenuVisible",
    value: function topMenuVisible(visible) {
      this.runner({
        "function": BRIDGE_INTERFACE.TOP_MENU_VISIBLE,
        visible: visible
      });
    }
  }, {
    key: "getFavoriteGroupInfos",
    value: function getFavoriteGroupInfos(type) {
      var _this3 = this;
      return new _Promise(function (resolve) {
        _this3.eventBus.once(APP_TO_WEB_EVENT.SEND_GROUP_INFOS, function (infos) {
          resolve(infos);
        });
        _this3.runner({
          "function": BRIDGE_INTERFACE.GET_FAVORITE_GROUP_INFOS,
          type: type
        });
      });
    }
  }, {
    key: "share",
    value: function share(message) {
      this.runner({
        "function": BRIDGE_INTERFACE.SHARE,
        message: message
      });
    }
  }, {
    key: "getUserInfo",
    value: function getUserInfo() {
      var _this4 = this;
      return new _Promise(function (resolve) {
        _this4.eventBus.once(APP_TO_WEB_EVENT.SEND_USER_INFO, function (info) {
          resolve(info);
        });
        _this4.runner({
          "function": BRIDGE_INTERFACE.GET_USER_INFO
        });
      });
    }
  }, {
    key: "getAppInfo",
    value: function getAppInfo() {
      var _this5 = this;
      return new _Promise(function (resolve) {
        _this5.eventBus.once(APP_TO_WEB_EVENT.SEND_APP_INFO, function (info) {
          resolve(info);
        });
        _this5.runner({
          "function": BRIDGE_INTERFACE.GET_APP_INFO
        });
      });
    }
  }, {
    key: "pageLoadClearHistory",
    value: function pageLoadClearHistory(url) {
      this.runner({
        "function": BRIDGE_INTERFACE.PAGE_LOAD_CLEAR_HISTORY,
        url: url
      });
    }
  }, {
    key: "upbitLink",
    value: function upbitLink() {
      this.runner({
        "function": BRIDGE_INTERFACE.UPBIT_LINK
      });
    }
  }, {
    key: "getAlarmState",
    value: function getAlarmState() {
      var _this6 = this;
      return new _Promise(function (resolve) {
        _this6.eventBus.once(APP_TO_WEB_EVENT.SET_ALARM_STATE, function (isTurnOn) {
          resolve(isTurnOn);
        });
        _this6.runner({
          "function": BRIDGE_INTERFACE.GET_ALARM_STATE
        });
      });
    }
  }, {
    key: "landingSetting",
    value: function landingSetting() {
      this.runner({
        "function": BRIDGE_INTERFACE.LANDING_SETTING
      });
    }
  }, {
    key: "postAppsflyerEvent",
    value: function postAppsflyerEvent(eventProperties) {
      var event = eventProperties.event,
        eventData = __rest(eventProperties, ["event"]);
      this.runner({
        "function": BRIDGE_INTERFACE.POST_APPSFLYER_EVENT,
        event: event,
        properties: eventData
      });
    }
  }, {
    key: "setWebContentHeight",
    value: function setWebContentHeight(height) {
      this.runner({
        "function": BRIDGE_INTERFACE.SET_WEB_CONTENT_HEIGHT,
        height: height
      });
    }
  }, {
    key: "getFontSizeLevel",
    value: function getFontSizeLevel() {
      var _this7 = this;
      return new _Promise(function (resolve) {
        _this7.eventBus.once(APP_TO_WEB_EVENT.SET_FONT_SIZE_LEVEL, function (level) {
          resolve(level);
        });
        _this7.runner({
          "function": BRIDGE_INTERFACE.GET_FONT_SIZE_LEVEL
        });
      });
    }
  }, {
    key: "getEmergencySkip",
    value: function getEmergencySkip() {
      var _this8 = this;
      return new _Promise(function (resolve) {
        _this8.eventBus.once(APP_TO_WEB_EVENT.SET_EMERGENCY_SKIP, function (isTurnOn) {
          resolve(isTurnOn);
        });
        _this8.runner({
          "function": BRIDGE_INTERFACE.GET_EMERGENCY_SKIP
        });
      });
    }
  }, {
    key: "calendarAddGroup",
    value: function calendarAddGroup(id, name) {
      this.runner({
        "function": BRIDGE_INTERFACE.CALENDAR_ADD_GROUP,
        id: id,
        name: name
      });
    }
  }, {
    key: "completeVerification",
    value: function completeVerification() {
      this.runner({
        "function": BRIDGE_INTERFACE.COMPLETE_VERIFICATION
      });
    }
  }, {
    key: "moveToMain",
    value: function moveToMain() {
      this.runner({
        "function": BRIDGE_INTERFACE.MOVE_TO_MAIN
      });
    }
  }, {
    key: "enableResizeByKeyboard",
    value: function enableResizeByKeyboard(adjustContentInset) {
      this.runner({
        "function": BRIDGE_INTERFACE.ENABLE_RESIZE_BY_KEYBOARD,
        adjustContentInset: adjustContentInset === false ? false : true
      });
    }
  }, {
    key: "showPostWriteButton",
    value: function showPostWriteButton(scheme) {
      this.runner({
        "function": BRIDGE_INTERFACE.SHOW_POST_WRITE_BUTTON,
        scheme: scheme
      });
    }
  }, {
    key: "getAssetChartImage",
    value: function getAssetChartImage(assetCode) {
      this.runner({
        "function": BRIDGE_INTERFACE.GET_ASSET_CHART_IMAGE,
        assetCode: assetCode || []
      });
    }
  }, {
    key: "getAppStorageData",
    value: function getAppStorageData(key) {
      var _this9 = this;
      return new _Promise(function (resolve) {
        _this9.appStorageEventDistributor.once(key, function (value) {
          resolve({
            key: key,
            value: value
          });
        });
        _this9.runner({
          "function": BRIDGE_INTERFACE.GET_APP_STORAGE_DATA,
          key: key
        });
      });
    }
  }, {
    key: "dispatchUpdateEvent",
    value: function dispatchUpdateEvent(key, data) {
      this.runner({
        "function": BRIDGE_INTERFACE.DISPATCH_UPDATE_EVENT,
        key: key,
        data: data
      });
    }
  }, {
    key: "setAppStorageData",
    value: function setAppStorageData(key, value) {
      this.runner({
        "function": BRIDGE_INTERFACE.SET_APP_STORAGE_DATA,
        key: key,
        value: value
      });
    }
  }, {
    key: "activatePullToRefresh",
    value: function activatePullToRefresh(isHandleByWeb) {
      this.runner({
        "function": BRIDGE_INTERFACE.ACTIVATE_PULL_TO_REFRESH,
        isHandleByWeb: isHandleByWeb
      });
    }
  }, {
    key: "completePullToRefresh",
    value: function completePullToRefresh() {
      this.runner({
        "function": BRIDGE_INTERFACE.COMPLETE_PULL_TO_REFRESH
      });
    }
  }, {
    key: "setDeviceBack",
    value: function setDeviceBack(enable) {
      this.runner({
        "function": BRIDGE_INTERFACE.SET_DEVICE_BACK,
        enable: enable
      });
    }
  }, {
    key: "closeAndMove",
    value: function closeAndMove(scheme) {
      this.runner({
        "function": BRIDGE_INTERFACE.CLOSE_AND_MOVE,
        scheme: scheme
      });
    }
  }, {
    key: "openUrl",
    value: function openUrl(url) {
      this.runner({
        "function": BRIDGE_INTERFACE.OPEN_URL,
        url: url
      });
    }
  }, {
    key: "setOverScroll",
    value: function setOverScroll(enable) {
      this.runner({
        "function": BRIDGE_INTERFACE.SET_OVER_SCROLL,
        enable: enable
      });
    }
  }, {
    key: "setEntireSwipeBack",
    value: function setEntireSwipeBack(enable) {
      this.runner({
        "function": BRIDGE_INTERFACE.SET_ENTIRE_SWIPE_BACK,
        enable: enable
      });
    }
  }, {
    key: "postBrazeEvent",
    value: function postBrazeEvent(eventProperties) {
      var _context;
      var name = eventProperties.name,
        properties = eventProperties.properties,
        dateProperties = eventProperties.dateProperties;
      this.runner({
        "function": BRIDGE_INTERFACE.POST_BRAZE_EVENT,
        name: name,
        properties: properties,
        dateProperties: dateProperties && _reduceInstanceProperty(_context = _Object$entries(dateProperties)).call(_context, function (prev, _ref2) {
          var _ref3 = _slicedToArray(_ref2, 2),
            key = _ref3[0],
            value = _ref3[1];
          prev[key] = value.getTime().toString();
          return prev;
        }, {})
      });
    }
  }, {
    key: "postBrazeUserAttribute",
    value: function postBrazeUserAttribute(eventProperties) {
      if ('value' in eventProperties) {
        this.runner({
          "function": BRIDGE_INTERFACE.POST_BRAZE_USER_ATTRIBUTE,
          key: eventProperties.key,
          value: eventProperties.value
        });
      } else {
        this.runner({
          "function": BRIDGE_INTERFACE.POST_BRAZE_USER_ATTRIBUTE,
          key: eventProperties.key,
          dateValue: eventProperties.dateValue.getTime().toString()
        });
      }
    }
  }, {
    key: "showPostTagFilterBottomSheet",
    value: function showPostTagFilterBottomSheet(_ref4) {
      var _ref4$selectedTag = _ref4.selectedTag,
        selectedTag = _ref4$selectedTag === void 0 ? null : _ref4$selectedTag,
        spUid = _ref4.spUid;
      this.runner({
        "function": BRIDGE_INTERFACE.SHOW_POST_TAG_FILTER_BOTTOM_SHEET,
        spUid: spUid,
        selectedTag: selectedTag
      });
    }
  }, {
    key: "halfView",
    value: function halfView(_ref5) {
      var url = _ref5.url,
        title = _ref5.title,
        subtitle = _ref5.subtitle,
        height = _ref5.height,
        type = _ref5.type;
      this.runner({
        "function": BRIDGE_INTERFACE.HALF_VIEW,
        url: url,
        title: title,
        subtitle: subtitle !== null && subtitle !== void 0 ? subtitle : null,
        height: height,
        type: type
      });
    }
  }, {
    key: "isAvailableFunction",
    value: function isAvailableFunction(name) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _this10 = this;
        var cancel, resultPromise, TIMEOUT_MS;
        return _regeneratorRuntime.wrap(function _callee$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              cancel = function cancel() {
                // do nothing
              };
              resultPromise = new _Promise(function (resolve) {
                cancel = _this10.isAvailableFunctionEventDistributor.once(name, function (isAvailable) {
                  resolve(isAvailable);
                });
                _this10.runner({
                  "function": BRIDGE_INTERFACE.IS_AVAILABLE_FUNCTION,
                  name: name
                });
              });
              _context2.prev = 2;
              // 앱 내부에서 해당 기능을 지원하는지 확인하는 과정이 오래 걸리지 않기 때문에 경험적인 작은 값을 사용
              TIMEOUT_MS = 300;
              _context2.next = 6;
              return withTimeout(resultPromise, TIMEOUT_MS);
            case 6:
              return _context2.abrupt("return", _context2.sent);
            case 9:
              _context2.prev = 9;
              _context2.t0 = _context2["catch"](2);
              cancel();
              throw _context2.t0;
            case 13:
            case "end":
              return _context2.stop();
          }
        }, _callee, null, [[2, 9]]);
      }));
    }
  }, {
    key: "showFollowingBottomSheetIfFirst",
    value: function showFollowingBottomSheetIfFirst(_ref6) {
      var key = _ref6.key,
        type = _ref6.type,
        name = _ref6.name;
      this.runner({
        "function": BRIDGE_INTERFACE.SHOW_FOLLOWING_BOTTOM_SHEET_IF_FIRST,
        type: type,
        name: name,
        key: key
      });
    }
  }, {
    key: "expandToolbar",
    value: function expandToolbar() {
      this.runner({
        "function": BRIDGE_INTERFACE.EXPAND_TOOLBAR
      });
    }
  }, {
    key: "collapseToolbar",
    value: function collapseToolbar() {
      this.runner({
        "function": BRIDGE_INTERFACE.COLLAPSE_TOOLBAR
      });
    }
  }, {
    key: "getInvestmentLevelImage",
    value: function getInvestmentLevelImage() {
      this.runner({
        "function": BRIDGE_INTERFACE.GET_INVESTMENT_LEVEL_IMAGE
      });
    }
  }, {
    key: "hidePostWriteButton",
    value: function hidePostWriteButton() {
      this.runner({
        "function": BRIDGE_INTERFACE.HIDE_POST_WRITE_BUTTON
      });
    }
  }, {
    key: "getAttachmentItems",
    value: function getAttachmentItems() {
      this.runner({
        "function": BRIDGE_INTERFACE.GET_ATTACHMENT_ITEMS
      });
    }
  }, {
    key: "reload",
    value: function reload() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var isSupportReload;
        return _regeneratorRuntime.wrap(function _callee2$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return this.isAvailableFunction('reload');
            case 2:
              isSupportReload = _context3.sent;
              if (isSupportReload) {
                this.runner({
                  "function": BRIDGE_INTERFACE.RELOAD
                });
              } else {
                location.reload();
              }
            case 4:
            case "end":
              return _context3.stop();
          }
        }, _callee2, this);
      }));
    }
  }, {
    key: "ready",
    value: function ready() {
      this.runner({
        "function": BRIDGE_INTERFACE.READY
      });
    }
  }, {
    key: "showUserTermsAgreement",
    value: function showUserTermsAgreement(key, redirectUrl) {
      this.runner({
        "function": BRIDGE_INTERFACE.SHOW_USER_TERMS_AGREEMENT,
        key: key,
        redirectUrl: redirectUrl
      });
    }
  }]);
  return IOSBridgeInterface;
}();

var scheme = 'stockplus://';
var schemeGenerator = {
  plustip: function plustip(id) {
    return "".concat(scheme, "plustip?id=").concat(id);
  },
  newsDetail: function newsDetail(id, section) {
    var _context;
    return _concatInstanceProperty(_context = "".concat(scheme, "newsDetail?section=").concat(section, "&id=")).call(_context, id);
  },
  disclosureDetail: function disclosureDetail(id) {
    return "".concat(scheme, "disclosure/").concat(id);
  },
  viewAsset: function viewAsset(option) {
    var _context2;
    var shortenCode = option.shortenCode,
      tabName = option.tabName,
      disclosureCategory = option.disclosureCategory;
    var queryParams = {
      code: shortenCode
    };
    if (tabName) {
      queryParams.tabName = tabName;
    }
    if (tabName === 'disclosure' && disclosureCategory) {
      queryParams.disclosureCategory = disclosureCategory;
    }
    return _reduceInstanceProperty(_context2 = _Object$entries(queryParams)).call(_context2, function (result, _ref, index) {
      var _context3, _context4, _context5;
      var _ref2 = _slicedToArray(_ref, 2),
        field = _ref2[0],
        value = _ref2[1];
      return _concatInstanceProperty(_context3 = _concatInstanceProperty(_context4 = _concatInstanceProperty(_context5 = "".concat(result)).call(_context5, index === 0 ? '?' : '&')).call(_context4, field, "=")).call(_context3, value);
    }, "".concat(scheme, "viewAsset"));
  },
  disclosureList: function disclosureList(category) {
    return "".concat(scheme, "disclosure/gather?category=").concat(category);
  },
  chatGpt: function chatGpt() {
    return "".concat(scheme, "chatGpt");
  },
  innerLink: function innerLink(url, title) {
    var _context6;
    var encodedUrl = encodeURIComponent(url);
    var encodedTitle = title ? encodeURIComponent(title) : '';
    return _concatInstanceProperty(_context6 = "".concat(scheme, "innerLink?url=").concat(encodedUrl, "&title=")).call(_context6, encodedTitle);
  },
  webView: function webView(url, title) {
    var _context7;
    var encodedUrl = encodeURIComponent(url);
    var encodedTitle = title ? encodeURIComponent(title) : '';
    return _concatInstanceProperty(_context7 = "".concat(scheme, "webView?url=").concat(encodedUrl)).call(_context7, title ? "&title=".concat(encodedTitle) : '');
  },
  outerLink: function outerLink(url) {
    var encodedUrl = encodeURIComponent(url);
    return "".concat(scheme, "outerLink?url=").concat(encodedUrl);
  },
  mainMenu: function mainMenu(option) {
    var _context8;
    var selectedTab = option.selectedTab;
    var queryParams;
    switch (selectedTab) {
      case 'favorite':
        queryParams = {
          selectedTab: selectedTab,
          groupId: option.groupId
        };
        break;
      case 'community':
        queryParams = {
          selectedTab: selectedTab,
          section: option.section
        };
        break;
      default:
        queryParams = {
          selectedTab: selectedTab
        };
    }
    return _reduceInstanceProperty(_context8 = _Object$entries(queryParams)).call(_context8, function (result, _ref3, index) {
      var _context9, _context10, _context11;
      var _ref4 = _slicedToArray(_ref3, 2),
        field = _ref4[0],
        value = _ref4[1];
      return _concatInstanceProperty(_context9 = _concatInstanceProperty(_context10 = _concatInstanceProperty(_context11 = "".concat(result)).call(_context11, index === 0 ? '?' : '&')).call(_context10, field, "=")).call(_context9, value);
    }, "".concat(scheme, "mainMenu"));
  },
  integratedSearch: function integratedSearch() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var queryString = getQueryString(params);
    return "".concat(scheme, "integratedSearch").concat(queryString);
  },
  imageViewer: function imageViewer(params) {
    var urls = params.urls,
      index = params.index;
    var queryString = getQueryString({
      imgUrl: urls.join(','),
      index: index
    });
    return "".concat(scheme, "imageViewer").concat(queryString);
  },
  postImageViewer: function postImageViewer(params) {
    var postId = params.postId,
      index = params.index;
    return "".concat(scheme, "imageViewer").concat(getQueryString({
      postId: postId,
      index: index
    }));
  },
  post: function post(id) {
    var queryString = getQueryString({
      postId: id
    });
    return "".concat(scheme, "post").concat(queryString);
  },
  plusFriendHome: function plusFriendHome(params) {
    var queryString = getQueryString(params);
    return "".concat(scheme, "plusFriendHome").concat(queryString);
  },
  alarm: function alarm(tabIndex) {
    var queryString = getQueryString({
      tabIndex: tabIndex
    });
    return "".concat(scheme, "alarm").concat(queryString);
  },
  viewTheme: function viewTheme(_ref5) {
    var key = _ref5.key,
      country = _ref5.country;
    var queryParams = {
      key: key
    };
    if (country) {
      queryParams.country = country;
    }
    return "".concat(scheme, "themeDetail").concat(getQueryString(queryParams));
  },
  membershipProgram: function membershipProgram() {
    return "".concat(scheme, "membershipProgram");
  },
  zendeskMessage: function zendeskMessage(_ref6) {
    var placeholder = _ref6.placeholder,
      ticketId = _ref6.ticketId;
    var queryParams = {};
    if (placeholder) {
      queryParams.placeholder = placeholder;
    }
    if (ticketId !== undefined) {
      queryParams.ticketId = ticketId;
    }
    return "".concat(scheme, "zendeskMessage").concat(getQueryString(queryParams));
  },
  userDashboard: function userDashboard(userId) {
    return "".concat(scheme, "userDashboard?userId=").concat(userId);
  },
  contact: function contact() {
    return "".concat(scheme, "contact");
  },
  reportPost: function reportPost(postId) {
    return "".concat(scheme, "report/post?id=").concat(postId);
  },
  reportComment: function reportComment(commentId) {
    return "".concat(scheme, "report/reply?id=").concat(commentId);
  },
  ranking: function ranking() {
    return "".concat(scheme, "ranking");
  },
  devicePermission: function devicePermission() {
    return "".concat(scheme, "devicePermission");
  },
  usaRealtimeApply: function usaRealtimeApply() {
    return "".concat(scheme, "usaRealtime/apply");
  },
  usaRealtimeTicket: function usaRealtimeTicket() {
    return "".concat(scheme, "usaRealtime/ticket");
  }
};
function getQueryString(params) {
  var _context12;
  return _reduceInstanceProperty(_context12 = _Object$entries(params)).call(_context12, function (result, _ref7, index) {
    var _context13, _context14, _context15;
    var _ref8 = _slicedToArray(_ref7, 2),
      field = _ref8[0],
      value = _ref8[1];
    if (value === undefined || value === null) {
      return result;
    }
    return _concatInstanceProperty(_context13 = _concatInstanceProperty(_context14 = _concatInstanceProperty(_context15 = "".concat(result)).call(_context15, index === 0 ? '?' : '&')).call(_context14, field, "=")).call(_context13, encodeURIComponent(value));
  }, '');
}

var AppScheme = /*#__PURE__*/function () {
  function AppScheme(openStrategy) {
    _classCallCheck(this, AppScheme);
    this.openStrategy = openStrategy;
  }
  _createClass(AppScheme, [{
    key: "changeStrategy",
    value: function changeStrategy(strategy) {
      this.openStrategy = strategy;
    }
  }, {
    key: "plustip",
    value: function plustip(id) {
      this.openStrategy.open(schemeGenerator.plustip(id));
    }
  }, {
    key: "newsDetail",
    value: function newsDetail(id, section) {
      this.openStrategy.open(schemeGenerator.newsDetail(id, section));
    }
  }, {
    key: "disclosureDetail",
    value: function disclosureDetail(id) {
      this.openStrategy.open(schemeGenerator.disclosureDetail(id));
    }
  }, {
    key: "viewAsset",
    value: function viewAsset(option) {
      this.openStrategy.open(schemeGenerator.viewAsset(option));
    }
  }, {
    key: "disclosureList",
    value: function disclosureList(category) {
      this.openStrategy.open(schemeGenerator.disclosureList(category));
    }
  }, {
    key: "chatGpt",
    value: function chatGpt() {
      this.openStrategy.open(schemeGenerator.chatGpt());
    }
  }, {
    key: "innerLink",
    value: function innerLink(url, title) {
      this.openStrategy.open(schemeGenerator.innerLink(url, title));
    }
    /**
     * innerLink와 동일하게 웹뷰를 띄우지만, 공용웹뷰를 사용합니다.
     * android에서 공용웹뷰 안정성이 확인되면 innerLink와 통합할 예정입니다.
     */
  }, {
    key: "webView",
    value: function webView(url, title) {
      this.openStrategy.open(schemeGenerator.webView(url, title));
    }
  }, {
    key: "outerLink",
    value: function outerLink(url) {
      this.openStrategy.open(schemeGenerator.outerLink(url));
    }
  }, {
    key: "mainMenu",
    value: function mainMenu(option) {
      this.openStrategy.open(schemeGenerator.mainMenu(option));
    }
  }, {
    key: "integratedSearch",
    value: function integratedSearch(option) {
      this.openStrategy.open(schemeGenerator.integratedSearch(option));
    }
  }, {
    key: "imageViewer",
    value: function imageViewer(option) {
      this.openStrategy.open(schemeGenerator.imageViewer(option));
    }
  }, {
    key: "postImageViewer",
    value: function postImageViewer(option) {
      this.openStrategy.open(schemeGenerator.postImageViewer(option));
    }
  }, {
    key: "post",
    value: function post(id) {
      this.openStrategy.open(schemeGenerator.post(id));
    }
  }, {
    key: "plusFriendHome",
    value: function plusFriendHome(option) {
      this.openStrategy.open(schemeGenerator.plusFriendHome(option));
    }
  }, {
    key: "alarm",
    value: function alarm(tabIndex) {
      this.openStrategy.open(schemeGenerator.alarm(tabIndex));
    }
  }, {
    key: "viewTheme",
    value: function viewTheme(option) {
      this.openStrategy.open(schemeGenerator.viewTheme(option));
    }
  }, {
    key: "membershipProgram",
    value: function membershipProgram() {
      this.openStrategy.open(schemeGenerator.membershipProgram());
    }
  }, {
    key: "zendeskMessage",
    value: function zendeskMessage(option) {
      this.openStrategy.open(schemeGenerator.zendeskMessage(option));
    }
    /**
     * 유저홈으로 이동
     */
  }, {
    key: "userDashboard",
    value: function userDashboard(userId) {
      this.openStrategy.open(schemeGenerator.userDashboard(userId));
    }
  }, {
    key: "contact",
    value: function contact() {
      this.openStrategy.open(schemeGenerator.contact());
    }
  }, {
    key: "reportPost",
    value: function reportPost(postId) {
      this.openStrategy.open(schemeGenerator.reportPost(postId));
    }
  }, {
    key: "reportComment",
    value: function reportComment(commentId) {
      this.openStrategy.open(schemeGenerator.reportComment(commentId));
    }
  }, {
    key: "ranking",
    value: function ranking() {
      this.openStrategy.open(schemeGenerator.ranking());
    }
  }, {
    key: "devicePermission",
    value: function devicePermission() {
      this.openStrategy.open(schemeGenerator.devicePermission());
    }
  }, {
    key: "usaRealtimeApply",
    value: function usaRealtimeApply() {
      this.openStrategy.open(schemeGenerator.usaRealtimeApply());
    }
  }, {
    key: "usaRealtimeTicket",
    value: function usaRealtimeTicket() {
      this.openStrategy.open(schemeGenerator.usaRealtimeTicket());
    }
  }]);
  return AppScheme;
}();

var DirectOpenStrategy = /*#__PURE__*/function () {
  function DirectOpenStrategy() {
    _classCallCheck(this, DirectOpenStrategy);
  }
  _createClass(DirectOpenStrategy, [{
    key: "open",
    value: function open(scheme) {
      if (typeof window !== 'undefined' && window.location) {
        window.location.href = scheme;
      }
    }
  }]);
  return DirectOpenStrategy;
}();

var OnelinkStrategy = /*#__PURE__*/function () {
  function OnelinkStrategy(onelinkUrl, pcLandingUrl) {
    _classCallCheck(this, OnelinkStrategy);
    this.onelinkUrl = onelinkUrl;
    this.pcLandingUrl = pcLandingUrl;
  }
  _createClass(OnelinkStrategy, [{
    key: "setOnelinkUrl",
    value: function setOnelinkUrl(onelinkUrl) {
      this.onelinkUrl = onelinkUrl;
    }
  }, {
    key: "setPCLandingUrl",
    value: function setPCLandingUrl(pcLandingUrl) {
      this.pcLandingUrl = pcLandingUrl;
    }
  }, {
    key: "open",
    value: function open(scheme) {
      if (typeof window !== 'undefined' && window.location) {
        var _context, _context2;
        window.location.href = _concatInstanceProperty(_context = _concatInstanceProperty(_context2 = "".concat(this.onelinkUrl, "?af_dp=")).call(_context2, encodeURIComponent(scheme))).call(_context, this.pcLandingUrl ? "&af_web_dp=".concat(encodeURIComponent(this.pcLandingUrl)) : '');
      }
    }
  }]);
  return OnelinkStrategy;
}();

var UserAgent = /*#__PURE__*/function () {
  function UserAgent(userAgent) {
    _classCallCheck(this, UserAgent);
    if (typeof userAgent !== 'string') {
      throw new Error('Empty Agent String');
    }
    this.originUserAgent = userAgent;
  }
  _createClass(UserAgent, [{
    key: "stockplus",
    get: function get() {
      var _context;
      return _includesInstanceProperty(_context = this.originUserAgent).call(_context, UserAgent.EXPECTED_AGENT_STRINGS.stockplus);
    }
  }, {
    key: "stockplusTrade",
    get: function get() {
      var _context2;
      return _includesInstanceProperty(_context2 = this.originUserAgent).call(_context2, UserAgent.EXPECTED_AGENT_STRINGS.stockplusTrade);
    }
  }, {
    key: "stockplusVirtualTrade",
    get: function get() {
      var _context3;
      return _includesInstanceProperty(_context3 = this.originUserAgent).call(_context3, UserAgent.EXPECTED_AGENT_STRINGS.stockplusVirtualTrade);
    }
  }, {
    key: "stockplusMain",
    get: function get() {
      return this.stockplus && !this.stockplusTrade && !this.stockplusVirtualTrade;
    }
  }, {
    key: "stockplusIOS",
    get: function get() {
      var _context4;
      return _includesInstanceProperty(_context4 = this.originUserAgent).call(_context4, UserAgent.EXPECTED_AGENT_STRINGS.stockplusIOS);
    }
  }, {
    key: "stockplusAndroid",
    get: function get() {
      var _context5;
      return _includesInstanceProperty(_context5 = this.originUserAgent).call(_context5, UserAgent.EXPECTED_AGENT_STRINGS.stockplusAndroid);
    }
  }, {
    key: "stockplusTradeIOS",
    get: function get() {
      var _context6;
      return _includesInstanceProperty(_context6 = this.originUserAgent).call(_context6, UserAgent.EXPECTED_AGENT_STRINGS.stockplusTradeIOS);
    }
  }, {
    key: "stockplusTradeAndroid",
    get: function get() {
      var _context7;
      return _includesInstanceProperty(_context7 = this.originUserAgent).call(_context7, UserAgent.EXPECTED_AGENT_STRINGS.stockplusTradeAndroid);
    }
  }, {
    key: "stockplusVirtualTradeIOS",
    get: function get() {
      var _context8;
      return _includesInstanceProperty(_context8 = this.originUserAgent).call(_context8, UserAgent.EXPECTED_AGENT_STRINGS.stockplusVirtualTradeIOS);
    }
  }, {
    key: "stockplusVirtualTradeAndroid",
    get: function get() {
      var _context9;
      return _includesInstanceProperty(_context9 = this.originUserAgent).call(_context9, UserAgent.EXPECTED_AGENT_STRINGS.stockplusVirtualTradeAndroid);
    }
  }, {
    key: "stockplusAppVersion",
    get: function get() {
      var _ref = this.originUserAgent.match(UserAgent.APP_VERSION_REGEXP) || [],
        _ref2 = _slicedToArray(_ref, 2),
        version = _ref2[1];
      return version !== null && version !== void 0 ? version : 'N/A';
    }
  }]);
  return UserAgent;
}();
UserAgent.EXPECTED_AGENT_STRINGS = {
  stockplus: 'StockPlus',
  stockplusTrade: 'StockPlus-Trade',
  stockplusVirtualTrade: 'StockPlus-VirtualTrade',
  stockplusIOS: 'StockPlus-iOS',
  stockplusAndroid: 'StockPlus-And',
  stockplusTradeIOS: 'StockPlus-Trade-iOS',
  stockplusTradeAndroid: 'StockPlus-Trade-And',
  stockplusVirtualTradeIOS: 'StockPlus-VirtualTrade-iOS',
  stockplusVirtualTradeAndroid: 'StockPlus-VirtualTrade-And'
};
UserAgent.APP_VERSION_REGEXP = /StockPlus-(?:iOS|And)\/(\d+\.\d+\.\d+(?:.\d+)?(?:_[a-zA-Z0-9]+)?)/;

var PostAmplitudeEvent = /*#__PURE__*/function () {
  function PostAmplitudeEvent(bridge) {
    _classCallCheck(this, PostAmplitudeEvent);
    this.bridge = bridge;
  }
  _createClass(PostAmplitudeEvent, [{
    key: "send",
    value: function send(properties) {
      this.bridge.postAmplitudeEvent(properties);
    }
  }]);
  return PostAmplitudeEvent;
}();

var TrackEvent = /*#__PURE__*/function () {
  function TrackEvent(bridge) {
    _classCallCheck(this, TrackEvent);
    this.bridge = bridge;
  }
  _createClass(TrackEvent, [{
    key: "send",
    value: function send(eventProperties) {
      var page = eventProperties.page,
        event = eventProperties.event,
        eventDetail = eventProperties.eventDetail,
        pageDetail = eventProperties.pageDetail;
      this.bridge.trackEvent({
        page: page,
        event: event,
        eventDetail: eventDetail,
        pageDetail: pageDetail
      });
    }
  }]);
  return TrackEvent;
}();

var UserEventTracker = /*#__PURE__*/function () {
  function UserEventTracker(collector) {
    _classCallCheck(this, UserEventTracker);
    this.collector = collector;
    this.baseProperties = {};
    if (!collector) {
      throw new Error('collector is required');
    }
  }
  _createClass(UserEventTracker, [{
    key: "setCollector",
    value: function setCollector(collector) {
      this.collector = collector;
    }
  }, {
    key: "send",
    value: function send(eventProperties) {
      var _a;
      (_a = this.collector) === null || _a === void 0 ? void 0 : _a.send(_Object$assign(_Object$assign({}, this.baseProperties), eventProperties));
    }
  }, {
    key: "setBaseProperties",
    value: function setBaseProperties(baseProperties) {
      this.baseProperties = baseProperties;
    }
  }, {
    key: "clearBaseProperties",
    value: function clearBaseProperties() {
      this.baseProperties = {};
    }
  }]);
  return UserEventTracker;
}();

var MAINTENANCE_CHECK_URL = {
  PROD: 'https://pages.stockplus.com/prod/app_status.json',
  DEV: 'https://pages.stockplus.com/dev/app_status.json'
};
var SKIP_MAINTENANCE_QUERY_NAME = '__skipMaintenanceCheck';
var MAINTENANCE_CHECK_TIMEOUT_MS = 1000;
var SKIP_MAINTENANCE_CHECK_TIMEOUT_MS = 1000;

var defaultFetch = function defaultFetch(url) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var response;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return fetch(url);
        case 2:
          response = _context.sent;
          return _context.abrupt("return", response.json());
        case 4:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
};
var NOT_MAINTENANCE_STATUS = {
  isMaintenance: false,
  redirectUrl: null
};
/**
 * 점검 상태 확인과 관련된 기능들을 제공하는 클래스
 */
var Maintenance = /*#__PURE__*/function () {
  function Maintenance(webToAppBridgeInterface) {
    var fetchInstance = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultFetch;
    _classCallCheck(this, Maintenance);
    this.webToAppBridgeInterface = webToAppBridgeInterface;
    this.fetchInstance = fetchInstance;
  }
  _createClass(Maintenance, [{
    key: "skipMaintenanceQueryName",
    get: function get() {
      return SKIP_MAINTENANCE_QUERY_NAME;
    }
  }, {
    key: "checkMaintenanceStatus",
    value: function checkMaintenanceStatus(_ref) {
      var phase = _ref.phase,
        _ref$searchParams = _ref.searchParams,
        searchParams = _ref$searchParams === void 0 ? '' : _ref$searchParams,
        _ref$timeout = _ref.timeout,
        _ref$timeout2 = _ref$timeout === void 0 ? {} : _ref$timeout,
        _ref$timeout2$mainten = _ref$timeout2.maintenanceCheckTimeout,
        maintenanceCheckTimeout = _ref$timeout2$mainten === void 0 ? MAINTENANCE_CHECK_TIMEOUT_MS : _ref$timeout2$mainten,
        _ref$timeout2$skipMai = _ref$timeout2.skipMaintenanceCheckTimeout,
        skipMaintenanceCheckTimeout = _ref$timeout2$skipMai === void 0 ? SKIP_MAINTENANCE_CHECK_TIMEOUT_MS : _ref$timeout2$skipMai;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var _yield$withTimeout, maintenance, maintenance_url;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              if (!this.checkSkipMaintenanceCheckUsingSearchParams({
                searchParams: searchParams
              })) {
                _context2.next = 3;
                break;
              }
              return _context2.abrupt("return", _Object$assign({}, NOT_MAINTENANCE_STATUS));
            case 3:
              _context2.next = 5;
              return waitUntil(this.checkSkipMaintenanceCheckUsingAppInterface(), skipMaintenanceCheckTimeout);
            case 5:
              if (!_context2.sent) {
                _context2.next = 7;
                break;
              }
              return _context2.abrupt("return", _Object$assign({}, NOT_MAINTENANCE_STATUS));
            case 7:
              _context2.next = 9;
              return withTimeout(this.fetchCommonMaintenanceStatus({
                phase: phase
              }), maintenanceCheckTimeout);
            case 9:
              _yield$withTimeout = _context2.sent;
              maintenance = _yield$withTimeout.maintenance;
              maintenance_url = _yield$withTimeout.maintenance_url;
              return _context2.abrupt("return", {
                isMaintenance: maintenance,
                redirectUrl: maintenance_url || null
              });
            case 15:
              _context2.prev = 15;
              _context2.t0 = _context2["catch"](0);
              if (!(_context2.t0 instanceof WebviewSDKError)) {
                _context2.next = 21;
                break;
              }
              throw _context2.t0;
            case 21:
              if (!(_context2.t0 instanceof Error)) {
                _context2.next = 25;
                break;
              }
              throw new WebviewSDKError(_context2.t0.message);
            case 25:
              throw new WebviewSDKError('Unknown error');
            case 26:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[0, 15]]);
      }));
    }
  }, {
    key: "fetchCommonMaintenanceStatus",
    value: function fetchCommonMaintenanceStatus(_ref2) {
      var phase = _ref2.phase;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var checkUrl, _yield$this$fetchInst, maintenance, maintenance_url;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              checkUrl = this.getCommonMaintenanceStatusCheckUrl(phase);
              _context3.next = 3;
              return this.fetchInstance(checkUrl);
            case 3:
              _yield$this$fetchInst = _context3.sent;
              maintenance = _yield$this$fetchInst.maintenance;
              maintenance_url = _yield$this$fetchInst.maintenance_url;
              return _context3.abrupt("return", {
                maintenance: maintenance,
                maintenance_url: maintenance ? maintenance_url : undefined
              });
            case 7:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
    }
  }, {
    key: "checkSkipMaintenanceCheckUsingSearchParams",
    value: function checkSkipMaintenanceCheckUsingSearchParams(_ref3) {
      var searchParams = _ref3.searchParams;
      var urlSearchParams = new _URLSearchParams(searchParams);
      var isSkip = urlSearchParams.get(this.skipMaintenanceQueryName) === 'true';
      return isSkip;
    }
  }, {
    key: "checkSkipMaintenanceCheckUsingAppInterface",
    value: function checkSkipMaintenanceCheckUsingAppInterface() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              _context4.next = 3;
              return this.webToAppBridgeInterface.getEmergencySkip();
            case 3:
              return _context4.abrupt("return", _context4.sent);
            case 6:
              _context4.prev = 6;
              _context4.t0 = _context4["catch"](0);
              return _context4.abrupt("return", false);
            case 9:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this, [[0, 6]]);
      }));
    }
  }, {
    key: "getCommonMaintenanceStatusCheckUrl",
    value: function getCommonMaintenanceStatusCheckUrl(phase) {
      var urlBase = phase === 'dev' ? MAINTENANCE_CHECK_URL.DEV : MAINTENANCE_CHECK_URL.PROD;
      try {
        // URL Constructor를 사용할 수 있다면 더 안전하게 searchParams로 추가
        var urlObject = new _URL(urlBase);
        if (!urlObject.hostname) {
          // 파싱이 잘못된 경우에도 fallback 처리
          throw new Error('URL Constructor is not supported');
        }
        urlObject.searchParams.append('time', _Date$now().toString());
        return urlObject.toString();
      } catch (_a) {
        var _context5;
        // safari 14.1 이전버전에서는 URL Constructor 버그로 사용할 수 없어 fallback
        // @see https://bugs.webkit.org/show_bug.cgi?id=216841
        return _concatInstanceProperty(_context5 = "".concat(urlBase, "?time=")).call(_context5, _Date$now());
      }
    }
  }]);
  return Maintenance;
}();

var initAppScheme = function initAppScheme(userAgent, schemeOpenStrategy) {
  var _ref = schemeOpenStrategy || {},
    _ref$stockplusApp = _ref.stockplusApp,
    stockplusApp = _ref$stockplusApp === void 0 ? new DirectOpenStrategy() : _ref$stockplusApp,
    _ref$browser = _ref.browser,
    browser = _ref$browser === void 0 ? new DirectOpenStrategy() : _ref$browser;
  if (userAgent.stockplus) {
    return new AppScheme(stockplusApp);
  } else {
    return new AppScheme(browser);
  }
};
var initBridgeInterface = function initBridgeInterface(userAgent, eventBus) {
  if (userAgent.stockplusAndroid) {
    return new AndroidBridgeInterface({
      runner: window.StockPlus,
      eventBus: eventBus
    });
  } else if (userAgent.stockplusIOS) {
    return new IOSBridgeInterface({
      runner: function runner(param) {
        var _a, _b, _c;
        return (_c = (_b = (_a = window.webkit) === null || _a === void 0 ? void 0 : _a.messageHandlers) === null || _b === void 0 ? void 0 : _b.StockPlusHandler) === null || _c === void 0 ? void 0 : _c.postMessage(param);
      },
      eventBus: eventBus
    });
  } else {
    return new BrowserBridgeInterface({
      eventBus: eventBus
    });
  }
};
var initAppToWebInterface = function initAppToWebInterface(eventBus) {
  var appToWebInterface = new AppToWebBridgeInterface(eventBus);
  if (!window.StockPlusWeb) {
    window.StockPlusWeb = {};
  }
  window.StockPlusWeb = _Object$assign(_Object$assign({}, window.StockPlusWeb), {
    setToken: function setToken(token) {
      return appToWebInterface.setToken(token);
    },
    setQuotationToken: function setQuotationToken(token) {
      return appToWebInterface.setQuotationToken(token);
    },
    sendAppInfo: function sendAppInfo(appInfo) {
      return appToWebInterface.sendAppInfo(appInfo);
    },
    sendBackKey: function sendBackKey() {
      return appToWebInterface.sendBackKey();
    },
    sendGroupInfos: function sendGroupInfos(infos) {
      return appToWebInterface.sendGroupInfos(infos);
    },
    sendUserInfo: function sendUserInfo(userId) {
      return appToWebInterface.sendUserInfo(userId);
    },
    setAlarmState: function setAlarmState(isTurnOn) {
      return appToWebInterface.setAlarmState(isTurnOn);
    },
    setFontSizeLevel: function setFontSizeLevel(level) {
      return appToWebInterface.setFontSizeLevel(level);
    },
    setEmergencySkip: function setEmergencySkip(isTurnOn) {
      return appToWebInterface.setEmergencySkip(isTurnOn);
    },
    sendClickShared: function sendClickShared() {
      return appToWebInterface.sendClickShared();
    },
    setAssetChartImage: function setAssetChartImage(imageData) {
      return appToWebInterface.setAssetChartImage(imageData);
    },
    sendAppStorageData: function sendAppStorageData(key, value) {
      return appToWebInterface.sendAppStorageData(key, value);
    },
    sendWebVisible: function sendWebVisible(isVisible) {
      return appToWebInterface.sendWebVisible(isVisible);
    },
    sendPullToRefresh: function sendPullToRefresh() {
      return appToWebInterface.sendPullToRefresh();
    },
    sendExpandingProgress: function sendExpandingProgress(weight) {
      return appToWebInterface.sendExpandingProgress(weight);
    },
    setPostTagFilter: function setPostTagFilter(assetKey, assetName) {
      return appToWebInterface.setPostTagFilter(assetKey, assetName);
    },
    setIsAvailableFunction: function setIsAvailableFunction(name, isAvailable) {
      return appToWebInterface.setIsAvailableFunction(name, isAvailable);
    },
    sendScrollTop: function sendScrollTop() {
      return appToWebInterface.sendScrollTop();
    },
    setInvestmentLevelImage: function setInvestmentLevelImage(imageData) {
      return appToWebInterface.setInvestmentLevelImage(imageData);
    },
    sendClickPostWrite: function sendClickPostWrite() {
      return appToWebInterface.sendClickPostWrite();
    },
    setAttachmentItems: function setAttachmentItems(items) {
      return appToWebInterface.setAttachmentItems(items);
    },
    sendEnterCommunity: function sendEnterCommunity() {
      return appToWebInterface.sendEnterCommunity();
    }
  });
};
/**
 * 하위호환성을 위해 window에도 추가해야 하는 인터페이스 목록.
 * 신규 인터페이스는 window.StockPlusWeb에만 추가되어야 합니다.
 */
var supportPreviousInterface = function supportPreviousInterface() {
  window.setToken = function (token) {
    var _a, _b;
    return (_b = (_a = window.StockPlusWeb) === null || _a === void 0 ? void 0 : _a.setToken) === null || _b === void 0 ? void 0 : _b.call(_a, token);
  };
  window.sendAppInfo = function (appInfo) {
    var _a, _b;
    return (_b = (_a = window.StockPlusWeb) === null || _a === void 0 ? void 0 : _a.sendAppInfo) === null || _b === void 0 ? void 0 : _b.call(_a, appInfo);
  };
  window.sendBackKey = function () {
    var _a, _b;
    return (_b = (_a = window.StockPlusWeb) === null || _a === void 0 ? void 0 : _a.sendBackKey) === null || _b === void 0 ? void 0 : _b.call(_a);
  };
  window.sendGroupInfos = function (infos) {
    var _a, _b;
    return (_b = (_a = window.StockPlusWeb) === null || _a === void 0 ? void 0 : _a.sendGroupInfos) === null || _b === void 0 ? void 0 : _b.call(_a, infos);
  };
  window.sendUserInfo = function (userId) {
    var _a, _b;
    return (_b = (_a = window.StockPlusWeb) === null || _a === void 0 ? void 0 : _a.sendUserInfo) === null || _b === void 0 ? void 0 : _b.call(_a, userId);
  };
  window.setAlarmState = function (isTurnOn) {
    var _a, _b;
    return (_b = (_a = window.StockPlusWeb) === null || _a === void 0 ? void 0 : _a.setAlarmState) === null || _b === void 0 ? void 0 : _b.call(_a, isTurnOn);
  };
  window.setFontSizeLevel = function (level) {
    var _a, _b;
    return (_b = (_a = window.StockPlusWeb) === null || _a === void 0 ? void 0 : _a.setFontSizeLevel) === null || _b === void 0 ? void 0 : _b.call(_a, level);
  };
  window.setEmergencySkip = function (isTurnOn) {
    var _a, _b;
    return (_b = (_a = window.StockPlusWeb) === null || _a === void 0 ? void 0 : _a.setEmergencySkip) === null || _b === void 0 ? void 0 : _b.call(_a, isTurnOn);
  };
  window.sendAppStorageData = function (key, value) {
    var _a, _b;
    return (_b = (_a = window.StockPlusWeb) === null || _a === void 0 ? void 0 : _a.sendAppStorageData) === null || _b === void 0 ? void 0 : _b.call(_a, key, value);
  };
  window.sendUserTermsAgreement = function () {
    // deprecated된 스펙이나 호출되는 경우가 있어 추가
  };
};
var stockplusSDK = {
  bridgeInterface: null,
  userAgent: null,
  eventBus: null,
  scheme: null,
  eventTracker: null,
  maintenance: null,
  init: function init(config) {
    if (typeof window === 'undefined') {
      throw new Error('window is empty');
    }
    this.eventBus = new EventBus();
    this.userAgent = new UserAgent(window.navigator.userAgent);
    this.scheme = initAppScheme(this.userAgent, config === null || config === void 0 ? void 0 : config.schemeOpenStrategy);
    this.bridgeInterface = initBridgeInterface(this.userAgent, this.eventBus);
    this.eventTracker = new UserEventTracker((config === null || config === void 0 ? void 0 : config.userEventCollector) || new PostAmplitudeEvent(this.bridgeInterface));
    this.maintenance = new Maintenance(this.bridgeInterface);
    initAppToWebInterface(this.eventBus);
    supportPreviousInterface();
  }
};

export { AndroidBridgeInterface, AppScheme, BrowserBridgeInterface, DirectOpenStrategy, EventBus, IOSBridgeInterface, OnelinkStrategy, PostAmplitudeEvent, TimeoutError, TrackEvent, UserAgent, UserEventTracker, WebviewSDKError, schemeGenerator, stockplusSDK };
//# sourceMappingURL=index.js.map
